// import React, { useEffect, useRef } from "react";
// import Acumen_25_Years_LOGO from "../assets/Acumen_25_Years_LOGO.png";

// // ─── DESIGN TOKENS ────────────────────────────────────────────────────────────
// const T = {
//   navy: "#A80D2C",
//   blue: "#C4163A",
//   teal: "#7B0F2B",
//   gold: "#D79A1E",
//   slate: "#5B677A",
//   bg: "#F5F8FC",
//   card: "#FFFFFF",
//   line: "#DCE5EF",
//   ink: "#1D2733",
//   orange: "#F97316",
// };

// const STYLE_COLOR = {
//   CO: T.navy,
//   CL: "#1A7A4A",
//   CM: T.gold,
//   AC: "#5B4A8A",
//   AV: T.orange,
// };

// // ─── STATIC LOOKUP TABLES (mirrored from NSResult.jsx) ───────────────────────
// const NS_DEFINITIONS = [
//   {
//     code: "CO", key: "competing", label: "Competing",
//     tagline: '"I focus on the bottom line and expect to win."',
//     assertiveness: "High", cooperativeness: "Low", bargaining: "Distributive Bargaining",
//     overview: "Negotiators with this style are results-oriented, self-confident, and assertive. They are focused primarily on the bottom line, tend to impose their views on the other party, and in the extreme can become aggressive and domineering.",
//     orgNote: "Competing is effective when quick, decisive action is needed or when you must stand firm on non-negotiable principles. Overuse, however, can damage relationships and reduce the quality of long-term outcomes. Pairing assertiveness with a degree of openness produces better results in recurring negotiations.",
//     toDo: [
//       "Recognise that winning every battle can mean losing the war — long-term relationships matter.",
//       "Practise listening actively to the other party's position before staking your own.",
//       "Reserve a hard-competing stance for situations where the outcome is truly non-negotiable.",
//       // "Explore whether Collaborating can achieve the same result while preserving the relationship.",
//     ],
//   },
//   {
//     code: "CL", key: "collaborating", label: "Collaborating",
//     tagline: '"Let\'s find a solution that works for both of us."',
//     assertiveness: "High", cooperativeness: "High", bargaining: "Mutual Gain Bargaining",
//     overview: "Negotiators with this style use open and honest communication, focus on finding creative solutions that mutually satisfy both parties, are open to exploring new and novel solutions, and suggest many alternatives for consideration.",
//     orgNote: "Collaborating is the gold standard for complex, long-term negotiations where relationship quality matters as much as the outcome. It requires trust and transparency from both parties. When the other side is not forthcoming, collaborators must be careful not to be exploited.",
//     toDo: [
//       "Continue investing in relationship-building before and during negotiations.",
//       "Prepare thoroughly — understanding the other party's interests is the foundation of joint solutions.",
//       "Be alert to situations where the other party is not collaborating in good faith.",
//       // "Share information openly, but verify that reciprocal transparency is present.",
//     ],
//   },
//   {
//     code: "CM", key: "compromising", label: "Compromising",
//     tagline: '"Let\'s meet halfway and both walk away satisfied."',
//     assertiveness: "Moderate", cooperativeness: "Moderate", bargaining: "Mixed",
//     overview: "Negotiators with this style aim to find the middle ground, often split the difference between positions, frequently engage in give-and-take tradeoffs, and accept moderate satisfaction of both parties' needs.",
//     orgNote: "Compromising is pragmatic and time-efficient. It works well when both parties have equal power and a quick resolution is preferable to a prolonged negotiation. It may, however, leave value on the table that a collaborative approach would have captured.",
//     toDo: [
//       "Ask whether splitting the difference is truly optimal or simply expedient.",
//       "Explore whether a creative trade on different issues could yield more for both sides.",
//       "Use compromising as a fallback when collaboration stalls, not as a first resort.",
//       // "Track the pattern — if you always compromise, the other party may anchor aggressively.",
//     ],
//   },
//   {
//     code: "AC", key: "accommodating", label: "Accommodating",
//     tagline: '"I value the relationship above my own outcome."',
//     assertiveness: "Low", cooperativeness: "High", bargaining: "Mutual Gain Bargaining",
//     overview: "Negotiators with this style make attempts to maintain relationships with the other party, smooth over conflicts, downplay differences, and are most concerned with satisfying the needs of the other party.",
//     orgNote: "Accommodating builds goodwill and can preserve important relationships, particularly when the issue at hand matters more to the other party. Chronically accommodating, however, leads to cumulative disadvantage and can signal weakness to strategic negotiators.",
//     toDo: [
//       "Distinguish between genuine accommodation (strategic relationship investment) and habitual yielding.",
//       "Assert your core interests clearly before conceding on secondary points.",
//       "Practise saying 'I need to think about that' rather than agreeing immediately.",
//       // "Balance relationship focus with outcome focus — your needs matter too.",
//     ],
//   },
//   {
//     code: "AV", key: "avoiding", label: "Avoiding",
//     tagline: '"I prefer to step back rather than engage in conflict."',
//     assertiveness: "Low", cooperativeness: "Low", bargaining: "Neither",
//     overview: "Negotiators with this style are passive, prefer to avoid conflict, make attempts to withdraw from the situation or pass responsibility onto another party, and fail to show adequate concern or make an honest attempt to get to a solution.",
//     orgNote: "Avoidance has a narrow legitimate application — deferring a trivial issue or a highly charged moment when emotions need to cool. Systematic avoidance, however, means unresolved issues accumulate and others fill the negotiating vacuum, often at your expense.",
//     toDo: [
//       "Identify which negotiations you are avoiding and ask what the cost of continued avoidance is.",
//       "Develop a simple opening script to step into difficult conversations with calm authority.",
//       "Distinguish between strategic timing (deferring wisely) and fear-driven withdrawal.",
//       // "Seek low-stakes practice negotiations to build comfort and confidence.",
//     ],
//   },
// ];

// const STYLE_BANDS = {
//   CO: { high: 18, mod_to_high: 16, mod_to_low: 14 },
//   AV: { high: 18, mod_to_high: 16, mod_to_low: 14 },
//   CL: { high: 21, mod_to_high: 19, mod_to_low: 17 },
//   AC: { high: 19, mod_to_high: 17, mod_to_low: 15 },
//   CM: { high: 20, mod_to_high: 18, mod_to_low: 16 },
// };

// const BAND_RANGES = {
//   CO: { High: "18 or above", "Moderate to High": "16–17", "Moderate to Low": "14–15", Low: "13 or below" },
//   AV: { High: "18 or above", "Moderate to High": "16–17", "Moderate to Low": "14–15", Low: "13 or below" },
//   CL: { High: "21 or above", "Moderate to High": "19–20", "Moderate to Low": "17–18", Low: "16 or below" },
//   AC: { High: "19 or above", "Moderate to High": "17–18", "Moderate to Low": "15–16", Low: "14 or below" },
//   CM: { High: "20 or above", "Moderate to High": "18–19", "Moderate to Low": "16–17", Low: "15 or below" },
// };

// const BAND_DESCRIPTIONS = {
//   CO: {
//     High: "You strongly exhibit Competing characteristics — results-oriented, self-confident, assertive, and focused on the bottom line. In the extreme this can appear aggressive. You are most aligned with Distributive Bargaining.",
//     "Moderate to High": "You moderately to strongly exhibit Competing characteristics. You advocate firmly for your position while retaining some openness to the other party.",
//     "Moderate to Low": "You exhibit mild Competing characteristics. You can assert yourself when necessary but generally prefer a less confrontational stance.",
//     Low: "You only weakly exhibit Competing characteristics. You are unlikely to use aggressive tactics or hard-positional bargaining.",
//   },
//   CL: {
//     High: "You strongly exhibit Collaborating characteristics — open communication, creativity, and a drive for joint solutions that satisfy both parties. This is the gold standard for Mutual Gain negotiations.",
//     "Moderate to High": "You moderately to strongly exhibit Collaborating characteristics. You seek win-win outcomes and invest in understanding the other party's interests.",
//     "Moderate to Low": "You exhibit mild Collaborating characteristics. You are open to joint problem-solving but may default to other styles under pressure.",
//     Low: "You only weakly exhibit Collaborating characteristics. You tend to approach negotiations as more distributive rather than joint problem-solving.",
//   },
//   CM: {
//     High: "You strongly exhibit Compromising characteristics — you naturally seek the middle ground, engage in give-and-take, and accept partial satisfaction as a fair outcome.",
//     "Moderate to High": "You moderately to strongly exhibit Compromising characteristics. You are pragmatic and tend to resolve deadlocks efficiently through mutual concession.",
//     "Moderate to Low": "You exhibit mild Compromising characteristics. You will split the difference when necessary but prefer to hold out for a better outcome.",
//     Low: "You only weakly exhibit Compromising characteristics. You tend to pursue full satisfaction rather than splitting the difference.",
//   },
//   AC: {
//     High: "You strongly exhibit Accommodating characteristics — you prioritise the relationship, smooth over conflict, and are most concerned with satisfying the other party's needs.",
//     "Moderate to High": "You moderately to strongly exhibit Accommodating characteristics. You are relationship-focused and generous in concessions, especially when you value the other party.",
//     "Moderate to Low": "You exhibit mild Accommodating characteristics. You balance relationship maintenance with the pursuit of your own interests.",
//     Low: "You only weakly exhibit Accommodating characteristics. You rarely yield for relationship reasons alone.",
//   },
//   AV: {
//     High: "You strongly exhibit Avoiding characteristics — you prefer to sidestep conflict, withdraw from negotiations, or pass responsibility rather than engage directly.",
//     "Moderate to High": "You moderately to strongly exhibit Avoiding characteristics. You may defer or delay negotiations and prefer others take the lead in conflict situations.",
//     "Moderate to Low": "You exhibit mild Avoiding characteristics. You occasionally step back from negotiations but can engage when necessary.",
//     Low: "You only weakly exhibit Avoiding characteristics. You are generally comfortable engaging in negotiations and conflict situations.",
//   },
// };

// function getStyleBandLabel(code, score) {
//   const b = STYLE_BANDS[code];
//   if (!b || score == null) return "—";
//   if (score >= b.high) return "High";
//   if (score >= b.mod_to_high) return "Moderate to High";
//   if (score >= b.mod_to_low) return "Moderate to Low";
//   return "Low";
// }

// function formatDate(date) {
//   return date.toLocaleDateString("en-GB", { day: "numeric", month: "long", year: "numeric" });
// }

// // ─── PENTAGON SVG ─────────────────────────────────────────────────────────────
// function PentagonSVG({ scores, dominantStyles }) {
//   const cx = 190, cy = 210, maxR = 130, size = 400;
//   const order = ["CL", "CO", "CM", "AV", "AC"];
//   const MAX_SCORE = 25;
//   const n = order.length;

//   function angle(i) { return (i * 360) / n - 90; }
//   function polar(deg, r) {
//     const rad = (deg * Math.PI) / 180;
//     return { x: cx + r * Math.cos(rad), y: cy + r * Math.sin(rad) };
//   }

//   const rings = [5, 10, 15, 20, 25];
//   const vertices = order.map((_, i) => polar(angle(i), maxR));

//   const scorePoints = order.map((code, i) => {
//     const r = ((scores?.[code] ?? 0) / MAX_SCORE) * maxR;
//     return polar(angle(i), Math.max(r, 2));
//   });
//   const polyStr = scorePoints.map(p => `${p.x.toFixed(1)},${p.y.toFixed(1)}`).join(" ");

//   return (
//     <svg viewBox={`0 0 ${size} ${size}`} width={size} height={size} style={{ display: "block", margin: "0 auto", overflow: "visible" }}>
//       {/* Grid rings */}
//       {rings.map(v => {
//         const pts = order.map((_, i) => polar(angle(i), (v / MAX_SCORE) * maxR));
//         return (
//           <polygon key={v}
//             points={pts.map(p => `${p.x.toFixed(1)},${p.y.toFixed(1)}`).join(" ")}
//             fill="none" stroke="#DCE5EF" strokeWidth={1}
//           />
//         );
//       })}
//       {/* Ring labels */}
//       {rings.map(v => {
//         const pt = polar(-90, (v / MAX_SCORE) * maxR);
//         return (
//           <text key={`rl-${v}`} x={pt.x + 4} y={pt.y} fontSize="9" fill={T.slate} dominantBaseline="middle"
//             style={{ fontFamily: "Arial, sans-serif" }}>{v}</text>
//         );
//       })}
//       {/* Axes */}
//       {vertices.map((pt, i) => (
//         <line key={i} x1={cx} y1={cy} x2={pt.x} y2={pt.y} stroke="#DCE5EF" strokeWidth={1} />
//       ))}
//       {/* Score polygon */}
//       <polygon points={polyStr} fill={`${T.navy}22`} stroke={T.navy} strokeWidth={2} strokeLinejoin="round" />
//       {/* Score dots */}
//       {scorePoints.map((pt, i) => {
//         const code = order[i];
//         const isDom = dominantStyles?.includes(code);
//         return (
//           <circle key={i} cx={pt.x} cy={pt.y} r={6}
//             fill={isDom ? STYLE_COLOR[code] : "#fff"}
//             stroke={STYLE_COLOR[code]} strokeWidth={2.5}
//           />
//         );
//       })}
//       {/* Axis labels */}
//       {order.map((code, i) => {
//         const LABEL_R = maxR + 30;
//         const pt = polar(angle(i), LABEL_R);
//         const isDom = dominantStyles?.includes(code);
//         const def = NS_DEFINITIONS.find(d => d.code === code);
//         return (
//           <g key={code}>
//             <text x={pt.x} y={pt.y - 8} textAnchor="middle" dominantBaseline="middle"
//               fontSize="13" fontWeight="700" fill={isDom ? STYLE_COLOR[code] : T.ink}
//               style={{ fontFamily: "Arial, sans-serif" }}>
//               {code}
//             </text>
//             <text x={pt.x} y={pt.y + 10} textAnchor="middle" dominantBaseline="middle"
//               fontSize="10" fill={T.slate} style={{ fontFamily: "Arial, sans-serif" }}>
//               {def?.label}
//             </text>
//           </g>
//         );
//       })}
//       {/* Centre label */}
//       <text x={cx} y={cy - 10} textAnchor="middle" fontSize="11" fill={T.slate} fontWeight="600"
//         style={{ fontFamily: "Arial, sans-serif" }}>STYLE</text>
//       <text x={cx} y={cy + 10} textAnchor="middle" fontSize="11" fill={T.slate} fontWeight="600"
//         style={{ fontFamily: "Arial, sans-serif" }}>PROFILE</text>
//     </svg>
//   );
// }

// // ─── 2D ASSERTIVENESS / COOPERATIVENESS SVG ───────────────────────────────────
// // Mirrors the Figure 1 diagram from the self-assessment: both axes are split into
// // 4 qualitative bands (Low / Moderate to Low / Moderate to High / High) with no
// // numbers shown — matching the official interpretation-guide bandings exactly.
// function TwoDGraphSVG({ assertivenessIndex, cooperativenessIndex }) {
//   const W = 900, H = 680;
//   const PAD = { top: 48, right: 48, bottom: 82, left: 138 };
//   const GW = W - PAD.left - PAD.right;
//   const GH = H - PAD.top - PAD.bottom;

//   const BANDS = ["Low", "Moderate to Low", "Moderate to High", "High"];

//   // Breakpoints map the raw index onto a continuous 0–4 scale across the 4 bands,
//   // using the exact cut-offs from the official interpretation tables:
//   //   Assertiveness:   Low ≤ -3 | Mod-to-Low -2..0 | Mod-to-High 1..4 | High ≥ 5
//   //   Cooperativeness: Low ≤ 1  | Mod-to-Low 2..4  | Mod-to-High 5..8 | High ≥ 9
//   const assertBreaks = [-8, -2.5, 0.5, 4.5, 9];
//   const coopBreaks = [-3, 1.5, 4.5, 8.5, 13];

//   const bandPosition = (value, breaks) => {
//     const v = value ?? (breaks[2] + breaks[1]) / 2;
//     const clamped = Math.max(breaks[0], Math.min(breaks[4], v));
//     for (let i = 0; i < 4; i++) {
//       if (clamped <= breaks[i + 1] || i === 3) {
//         const segStart = breaks[i], segEnd = breaks[i + 1];
//         const frac = segEnd === segStart ? 0.5 : (clamped - segStart) / (segEnd - segStart);
//         return i + frac;
//       }
//     }
//     return 2;
//   };

//   const assertPos = bandPosition(assertivenessIndex, assertBreaks); // 0 (Low) → 4 (High)
//   const coopPos = bandPosition(cooperativenessIndex, coopBreaks);

//   const cx = PAD.left + (coopPos / 4) * GW;
//   const cy = PAD.top + (1 - assertPos / 4) * GH;

//   const axisX = PAD.left + 0.5 * GW; // Low/High midline
//   const axisY = PAD.top + 0.5 * GH;

//   return (
//     <svg viewBox={`0 0 ${W} ${H}`} width={W} height={H}
//       style={{ display: "block", margin: "0 auto", fontFamily: "Arial, sans-serif" }}>

//       {/* Quadrant fills */}
//       {/* Competing — top-left */}
//       <rect x={PAD.left} y={PAD.top} width={axisX - PAD.left} height={axisY - PAD.top}
//         fill="rgba(239,68,68,0.07)" />
//       {/* Collaborating — top-right */}
//       <rect x={axisX} y={PAD.top} width={W - PAD.right - axisX} height={axisY - PAD.top}
//         fill="rgba(34,197,94,0.07)" />
//       {/* Avoiding — bottom-left */}
//       <rect x={PAD.left} y={axisY} width={axisX - PAD.left} height={H - PAD.bottom - axisY}
//         fill="rgba(100,116,139,0.07)" />
//       {/* Accommodating — bottom-right */}
//       <rect x={axisX} y={axisY} width={W - PAD.right - axisX} height={H - PAD.bottom - axisY}
//         fill="rgba(59,130,246,0.07)" />

//       {/* Graph border */}
//       <rect x={PAD.left} y={PAD.top} width={GW} height={GH}
//         fill="none" stroke="#DCE5EF" strokeWidth={1} />

//       {/* Band grid lines (dividers between Low / Mod-Low / Mod-High / High) */}
//       {[1, 2, 3].map(i => {
//         const gx = PAD.left + (i / 4) * GW;
//         const gy = PAD.top + (i / 4) * GH;
//         return (
//           <g key={i}>
//             {i !== 2 && <line x1={gx} y1={PAD.top} x2={gx} y2={H - PAD.bottom} stroke="rgba(148,163,184,0.25)" strokeWidth={1} />}
//             {i !== 2 && <line x1={PAD.left} y1={gy} x2={W - PAD.right} y2={gy} stroke="rgba(148,163,184,0.25)" strokeWidth={1} />}
//           </g>
//         );
//       })}

//       {/* Compromising — dashed border around the central 4 grid cells */}
//       <rect x={PAD.left + 0.25 * GW} y={PAD.top + 0.25 * GH} width={0.5 * GW} height={0.5 * GH}
//         fill="rgba(234,179,8,0.10)" stroke="rgba(202,138,4,0.6)" strokeWidth={2}
//         strokeDasharray="6 4" />

//       {/* Center axes */}
//       <line x1={axisX} y1={PAD.top} x2={axisX} y2={H - PAD.bottom} stroke="#94a3b8" strokeWidth={2} />
//       <line x1={PAD.left} y1={axisY} x2={W - PAD.right} y2={axisY} stroke="#94a3b8" strokeWidth={2} />

//       {/* Y-axis band labels (assertiveness) */}
//       {BANDS.map((label, i) => {
//         const gy = PAD.top + (1 - (i + 0.5) / 4) * GH;
//         return (
//           <text key={`y-${label}`} x={PAD.left - 10} y={gy} fontSize="10.5" fill="#475569" fontWeight="700"
//             textAnchor="end" dominantBaseline="middle">{label}</text>
//         );
//       })}

//       {/* X-axis band labels (cooperativeness) */}
//       {BANDS.map((label, i) => {
//         const gx = PAD.left + ((i + 0.5) / 4) * GW;
//         return (
//           <text key={`x-${label}`} x={gx} y={H - PAD.bottom + 20} fontSize="10.5" fill="#475569" fontWeight="700"
//             textAnchor="middle">{label}</text>
//         );
//       })}

//       {/* Quadrant labels */}
//       <text x={PAD.left + 18} y={PAD.top + 36} fontSize="16" fontWeight="800" fill="#dc2626">Competing</text>
//       <text x={W - PAD.right - 18} y={PAD.top + 36} fontSize="16" fontWeight="800" fill="#16a34a" textAnchor="end">Collaborating</text>
//       <text x={PAD.left + 18} y={H - PAD.bottom - 28} fontSize="16" fontWeight="800" fill="#64748b">Avoiding</text>
//       <text x={W - PAD.right - 18} y={H - PAD.bottom - 28} fontSize="16" fontWeight="800" fill="#2563eb" textAnchor="end">Accommodating</text>

//       {/* Compromising label */}
//       <rect x={axisX - 64} y={axisY - 16} width={130} height={32} rx={16}
//         fill="#ffffff" stroke="rgba(202,138,4,0.4)" strokeWidth={1.5} />
//       <text x={axisX + 1} y={axisY + 5} fontSize="13" fontWeight="800" fill="#ca8a04"
//         textAnchor="middle">Compromising</text>

//       {/* Axis direction labels */}
//       <text x={axisX} y={H - 40} fontSize="13" fontWeight="800" fill={T.ink} textAnchor="middle">Cooperativeness</text>
//       <text x={axisX} y={H - 18} fontSize="12" fontStyle="italic" fontWeight="600" fill={T.ink} textAnchor="middle">Mutual Gain Bargaining</text>
//       <text x={14} y={H / 2} fontSize="13" fontWeight="800" fill={T.ink}
//         textAnchor="middle" transform={`rotate(-90, 14, ${H / 2})`}>Assertiveness</text>
//       <text x={32} y={H / 2} fontSize="12" fontStyle="italic" fontWeight="600" fill={T.ink}
//         textAnchor="middle" transform={`rotate(-90, 32, ${H / 2})`}>Distributive Bargaining</text>
//       <text x={W - 10} y={H / 2} fontSize="13" fontWeight="800" fill={T.ink}
//         textAnchor="middle" transform={`rotate(90, ${W - 10}, ${H / 2})`}>High Coop. ►</text>

//       {/* User dot */}
//       <circle cx={cx} cy={cy} r={14} fill="#7c3aed" stroke="white" strokeWidth={4}
//         style={{ filter: "drop-shadow(0 4px 8px rgba(124,58,237,0.4))" }} />
//       {/* Tooltip bubble */}
//       <rect x={cx - 58} y={cy + 20} width={118} height={30} rx={10}
//         fill="#111827" />
//       <text x={cx + 1} y={cy + 40} fontSize="12" fontWeight="600" fill="white"
//         textAnchor="middle">Your Position</text>
//     </svg>
//   );
// }

// // ═══════════════════════════════════════════════════════════════════════════════
// export default function HiddenNSReport({ participantData, onComplete }) {
//   const containerRef = useRef(null);
//   const hasGenerated = useRef(false);

//   // ── Load html2canvas + jsPDF once ─────────────────────────────────────────
//   useEffect(() => {
//     let pending = 2;
//     const done = () => { pending--; };
//     const load = (src, id) => {
//       if (document.getElementById(id)) { done(); return; }
//       const s = document.createElement("script");
//       s.id = id; s.src = src; s.onload = done; s.onerror = done;
//       document.head.appendChild(s);
//     };
//     load("https://cdnjs.cloudflare.com/ajax/libs/html2canvas/1.4.1/html2canvas.min.js", "h2c-ns-v1");
//     load("https://cdnjs.cloudflare.com/ajax/libs/jspdf/2.5.1/jspdf.umd.min.js", "jspdf-ns-v1");
//   }, []);

//   // ── Generate PDF whenever participantData is set ──────────────────────────
//   useEffect(() => {
//     if (!participantData || hasGenerated.current) return;
//     hasGenerated.current = true;

//     const generate = async () => {
//       await new Promise((res) => {
//         const check = () => {
//           if (window.html2canvas && window.jspdf?.jsPDF) { res(); return; }
//           setTimeout(check, 100);
//         };
//         check();
//       });

//       await new Promise((r) => setTimeout(r, 1400));

//       const el = containerRef.current;
//       if (!el) { onComplete?.(); return; }

//       try {
//         const { jsPDF } = window.jspdf;
//         const A4_W = 210, A4_H = 297;

//         const pageEls = Array.from(el.querySelectorAll(".ns-page"));
//         const pdf = new jsPDF({ unit: "mm", format: "a4", orientation: "portrait" });

//         for (let i = 0; i < pageEls.length; i++) {
//           const canvas = await window.html2canvas(pageEls[i], {
//             scale: 2, useCORS: true, allowTaint: true, logging: false,
//             backgroundColor: "#ffffff",
//             width: pageEls[i].scrollWidth, height: pageEls[i].scrollHeight,
//             windowWidth: pageEls[i].scrollWidth,
//           });

//           const imgData = canvas.toDataURL("image/jpeg", 0.95);
//           const logicalW = canvas.width / 2;
//           const logicalH = canvas.height / 2;
//           const MM_PER_PX = 25.4 / 96;
//           const naturalW = logicalW * MM_PER_PX;
//           const naturalH = logicalH * MM_PER_PX;
//           const scaleToW = A4_W / naturalW;
//           const projectedH = naturalH * scaleToW;

//           let imgW, imgH, xOff, yOff;
//           if (projectedH <= A4_H) {
//             imgW = A4_W; imgH = projectedH; xOff = 0; yOff = 0;
//           } else {
//             const scaleToH = A4_H / naturalH;
//             imgW = naturalW * scaleToH; imgH = A4_H;
//             xOff = (A4_W - imgW) / 2; yOff = 0;
//           }

//           if (i > 0) pdf.addPage();
//           pdf.addImage(imgData, "JPEG", xOff, yOff, imgW, imgH);
//         }

//         const safeName = (participantData.userInfo?.name || "Report").replace(/\s+/g, "_");
//         pdf.save(`NS_Report_${safeName}.pdf`);
//       } catch (err) {
//         console.error("NS PDF generation failed", err);
//       } finally {
//         hasGenerated.current = false;
//         onComplete?.();
//       }
//     };

//     generate();
//   }, [participantData]); // eslint-disable-line react-hooks/exhaustive-deps

//   if (!participantData) return null;

//   // ── Derive display values ──────────────────────────────────────────────────
//   const {
//     userInfo = {},
//     nsData = {},
//     scores = {},
//     dominantStyles = [],
//     insightText = "",
//     submission_time,
//   } = participantData;

//   const participant = userInfo.name || "—";
//   const assessmentDate = formatDate(
//     submission_time
//       ? new Date(submission_time)
//       : new Date()
//   );
//   const assertiveness = nsData?.assertiveness ?? {};
//   const cooperativeness = nsData?.cooperativeness ?? {};

//   const stylesForDisplay = NS_DEFINITIONS.map(def => {
//     const apiStyle = nsData?.styles?.[def.key];
//     const score = apiStyle?.score ?? scores[def.code] ?? null;
//     const bandLabel = apiStyle?.band_label ?? getStyleBandLabel(def.code, score);
//     const isDominant = dominantStyles.includes(def.code);
//     return { def, score, bandLabel, isDominant };
//   });

//   // Sorted highest-score-first — used only for Pages 3 & 4
//   const stylesForDisplaySorted = [...stylesForDisplay].sort(
//     (a, b) => (b.score ?? -Infinity) - (a.score ?? -Infinity)
//   );

//   const dominantDef = NS_DEFINITIONS.find(d => dominantStyles.includes(d.code));

//   const BAR_FILL = `linear-gradient(90deg,${T.navy},${T.blue},${T.gold})`;
//   const BAR_FILL_DOMINANT = (code) => `linear-gradient(90deg,${STYLE_COLOR[code]},${STYLE_COLOR[code]}aa)`;

//   // ── Render ─────────────────────────────────────────────────────────────────
//   return (
//     <div
//       ref={containerRef}
//       aria-hidden="true"
//       style={{
//         position: "fixed", top: "0", left: "-9999px",
//         width: "1100px", opacity: 0, pointerEvents: "none", zIndex: -1,
//       }}
//     >
//       <link
//         href="https://fonts.googleapis.com/css2?family=Inter:wght@300;400;500;600;700;800;900&display=swap"
//         rel="stylesheet"
//       />

//       {/* ── All CSS scoped under .ns-pdf-root ── */}
//       <style>{`
//         .ns-pdf-root {
//           font-family: 'Inter', Arial, sans-serif;
//           background: #F5F8FC;
//           color: #1D2733;
//           line-height: 1.55;
//         }
//         .ns-pdf-root .report { max-width:1100px; margin:0 auto; padding:1.5rem 1rem 3rem; }

//         /* ── Page shell ── */
//         .ns-pdf-root .ns-page {
//           background: #ffffff;
//           border: 1px solid #DCE5EF;
//           border-radius: 24px;
//           box-shadow: 0 14px 36px rgba(11,31,58,.10);
//           overflow: hidden;
//           margin-bottom: 1.5rem;
//         }

//         /* ── Cover ── */
//         .ns-pdf-root .cover { min-height:1556px; position:relative; color:white; }
//         .ns-pdf-root .cover-inner { padding:3.5rem; display:flex; flex-direction:column; justify-content:space-between; min-height:1556px; }
//         .ns-pdf-root .brand { display:flex; align-items:center; justify-content:space-between; gap:1rem; }
//         .ns-pdf-root .brand-left { display:flex; align-items:center; gap:1rem; }
//         .ns-pdf-root .logo { width:60px; height:60px; border-radius:16px; display:grid; place-items:center; font-weight:900; font-size:1.1rem; letter-spacing:.06em; flex-shrink:0; }
//         .ns-pdf-root .brand h1 { margin:0; font-size:1.2rem; letter-spacing:.07em; text-transform:uppercase; }
//         .ns-pdf-root .brand p  { margin:.15rem 0 0; color:rgba(255,255,255,.72); font-size:0.85rem; }
//         .ns-pdf-root .badge { border:1px solid rgba(255,255,255,.2); background:rgba(255,255,255,.1); padding:.5rem 1rem; border-radius:999px; font-size:0.76rem; }
//         .ns-pdf-root .cover-title h2 {margin:0 0 1rem; font-size:3.4rem;line-height:.95; color:#FFFFFF;white-space:nowrap; max-width:none; border-left: 6px solid #FFFFFF !important; padding-left: 1rem;}
//         .ns-pdf-root .cover-title p  { text-align: justify; font-size:1.2rem; color:rgba(255,255,255,.82); max-width:100%; }
//         .ns-pdf-root .cover-grid { display:grid; grid-template-columns:repeat(3,1fr); gap:1rem; margin-top:2.5rem; }
//         .ns-pdf-root .meta { background:rgba(255,255,255,.1); font-size:1.2rem; border:1px solid rgba(255,255,255,.14); border-radius:16px; padding:.9rem 1rem; }
//         .ns-pdf-root .meta span   { display:block; font-size:0.75rem; color:rgba(255,255,255,.65); margin-bottom:.2rem; }
//         .ns-pdf-root .meta strong { font-size:0.95rem; color:#FFFFFF; }
//         .ns-pdf-root .cover-badges { display:flex; flex-wrap:wrap; gap:.6rem; margin-top:2rem; }
//         .ns-pdf-root .cover-badge  { background:rgba(255,255,255,.12); border:1px solid rgba(255,255,255,.18); padding:.5rem .9rem; border-radius:999px; font-size:0.95rem; }
//         .ns-pdf-root .footer-note { display:flex; justify-content:space-between; gap:1rem; color:rgba(255,255,255,.68); font-size:0.75rem; margin-top:2rem; }

//         .ns-pdf-root .logo-panel {
//           position: absolute;
//           top: 0;
//           right: 0;
//           width: 500px;
//           height: 250px;
//           display: flex;
//           align-items: center;
//           justify-content: center;
//           z-index: 1;
//         }
//         .ns-pdf-root .logo-panel-inner {
//           display: flex;
//           flex-direction: column;
//           align-items: center;
//           position: relative;
//           z-index: 2;
//           padding-left: 60px;
//           padding-bottom: 25px;
//         }
//         .ns-pdf-root .logo-img { height: 65px; width: auto; object-fit: contain; flex-shrink: 0; }

//         /* ── Inner pages ── */
//         .ns-pdf-root .page-inner { padding:2.5rem; padding-bottom:0rem; }
//         .ns-pdf-root .topbar { display:flex; justify-content:space-between; align-items:flex-start; gap:1rem; margin-bottom:1.75rem; }
//         .ns-pdf-root .section-kicker { font-size:0.72rem; text-transform:uppercase; letter-spacing:.12em; font-weight:700; }
//         .ns-pdf-root .section-title { margin:.35rem 0 0; font-size:clamp(1.45rem,1.2rem + 1.1vw,2rem); color:#0f2744; border-left: 5px solid #C4163A; padding-left: .75rem; }

//         /* ── Cards ── */
//         .ns-pdf-root .card { background:#ffffff; border:1px solid #DCE5EF; border-radius:18px; padding:1.25rem; box-shadow:0 4px 14px rgba(16,24,40,.05); }
//         .ns-pdf-root .card h3 { margin:0 0 .65rem; font-size:1.05rem; color:#1D2733; }
//         .ns-pdf-root .lead { color:#334155; font-size:0.93rem; margin:0; }

//         /* ── Sub-panels ── */
//         .ns-pdf-root .sub-panel { background:#fbfdff; border:1px solid #DCE5EF; border-radius:14px; padding:1rem; }
//         .ns-pdf-root .sub-panel h4 { margin:0 0 .6rem; font-size:.95rem; color:#1D2733; }

//         /* ── Score tiles ── */
//         .ns-pdf-root .score-tile-grid { display:grid; grid-template-columns:repeat(5,1fr); gap:.6rem; margin-top:.85rem; }
//         .ns-pdf-root .score-tile { border-radius:14px; border:1px solid #DCE5EF; padding:.75rem; background:linear-gradient(180deg,#fff,#f8fbff); text-align:center; }
//         .ns-pdf-root .score-tile span   { display:block; font-size:0.68rem; letter-spacing:.08em; text-transform:uppercase; color:#5B677A; font-weight:700; margin-bottom:.2rem; }
//         .ns-pdf-root .score-tile strong { font-size:1.7rem; color:#A80D2C; font-weight:700; display:block; }
//         .ns-pdf-root .score-tile .band  { font-size:0.68rem; font-weight:700; text-transform:uppercase; letter-spacing:.05em; margin-top:.2rem; }

//         /* ── Bars ── */
//         .ns-pdf-root .bar-row { display:grid; grid-template-columns:200px 1fr 48px; gap:10px; align-items:center; margin-bottom:.65rem; }
//         .ns-pdf-root .bar-label { font-size:0.88rem; color:#1D2733; }
//         .ns-pdf-root .bar-label.dominant { font-weight:700; }
//         .ns-pdf-root .track { height:10px; background:#EAF0F6; border-radius:999px; overflow:hidden; }
//         .ns-pdf-root .fill  { height:100%; border-radius:999px; }
//         .ns-pdf-root .score-val { text-align:right; font-size:0.85rem; font-weight:700; color:#A80D2C; }

//         /* ── Callout ── */
//         .ns-pdf-root .callout { background:linear-gradient(180deg,#fff9e8,#fffdf2); border:1px solid #F2D58A; border-radius:14px; padding:.85rem 1rem; font-size:0.88rem; line-height:1.6; }

//         /* ── Index cards ── */
//         .ns-pdf-root .index-grid { display:grid; grid-template-columns:1fr 1fr; gap:1rem; margin-top:1.25rem; }
//         .ns-pdf-root .index-card { border-radius:14px; padding:1rem 1.1rem; }
//         .ns-pdf-root .index-card.positive { background:linear-gradient(180deg,#f0fff4,#e8fdf0); border:1px solid #86efac; }
//         .ns-pdf-root .index-card.negative { background:linear-gradient(180deg,#fff5f0,#fdeaea); border:1px solid #fca5a5; }
//         .ns-pdf-root .index-value { font-size:2.4rem; font-weight:700; line-height:1; }
//         .ns-pdf-root .index-badge { border-radius:999px; padding:3px 12px; font-size:.75rem; font-weight:700; color:#fff; display:inline-block; margin-top:.4rem; }

//         /* ── Style profile cards ── */
//         .ns-pdf-root .profile-card { border:1px solid #DCE5EF; border-radius:16px; padding:1rem; margin-bottom:.25rem; background:#fff; }
//         .ns-pdf-root .profile-card.active { box-shadow:0 0 0 2px rgba(168,13,44,.18); }
//         .ns-pdf-root .profile-header { display:flex; align-items:center; gap:.85rem; margin-bottom:.3rem; }
//         .ns-pdf-root .profile-dot { width:14px; height:14px; border-radius:50%; flex-shrink:0; }
//         .ns-pdf-root .profile-meta strong { display:block; font-size:.97rem; color:#1D2733; }
//         .ns-pdf-root .profile-meta em     { font-style:italic; font-size:.82rem; color:#5B677A; }
//         .ns-pdf-root .profile-meta .thresholds { font-size:.75rem; color:#5B677A; margin-top:.15rem; }
//         .ns-pdf-root .profile-card p { margin:0 0 .2rem; font-size:0.84rem; color:#334155; }
//         .ns-pdf-root .your-tag { display:inline-block; font-size:.68rem; font-weight:700; letter-spacing:.03em; margin-left:.5rem; padding:2px 10px; border-radius:999px; color:#fff; vertical-align:middle; text-transform:uppercase; }
//         .ns-pdf-root .dim-badge { border-radius:999px; padding:3px 10px; font-size:.75rem; font-weight:600; display:inline-block; margin:.2rem .3rem .2rem 0; }

//         /* ── Analysis items ── */
//         .ns-pdf-root .analysis-item { border:1px solid #DCE5EF; border-radius:16px; padding:1rem; margin-bottom:.75rem; background:#fff; }
//         .ns-pdf-root .analysis-item h4 { margin:0 0 .5rem; font-size:.97rem; }
//         .ns-pdf-root .analysis-item p  { margin:0 0 .35rem; font-size:0.84rem; color:#334155; }
//         .ns-pdf-root .analysis-item ul { margin:.3rem 0 0; padding-left:18px; font-size:0.84rem; color:#334155; line-height:1.6; }
//         .ns-pdf-root .band-section { border-radius:10px; padding:.65rem .85rem; margin-bottom:.5rem; border:1px solid #DCE5EF; background:#f8fbff; }
//         .ns-pdf-root .band-section.active-band { background:#fffdf5; }

//         /* ── Two-col ── */
//         .ns-pdf-root .two-col { display:grid; grid-template-columns:1fr 1fr; gap:1.2rem; }

//         /* ── Back cover ── */
//         .ns-pdf-root .back-cover { min-height:1556px; color:white; }
//         .ns-pdf-root .back-cover .page-inner { min-height:1556px; display:flex; flex-direction:column; justify-content:space-between; }
//         .ns-pdf-root .closing h2 { margin:0 0 .85rem; font-size:2.8rem; color:#FFFFFF; border-left: 6px solid #FFFFFF !important; padding-left: 1rem; }
//         .ns-pdf-root .closing p  { text-align: justify; max-width: 100%; color:rgba(255,255,255,.82); font-size:1.2rem; }
//         .ns-pdf-root .contact-grid { display:grid; grid-template-columns:repeat(3,1fr); gap:1rem; margin-top:1.75rem; }
//         .ns-pdf-root .contact { background:rgba(193,24,24,.1); border:1px solid rgba(255,255,255,.16); border-radius:16px; padding:.9rem; }
//         .ns-pdf-root .contact span   { display:block; color:rgba(255,255,255,.64); font-size:0.73rem; margin-bottom:.25rem; }
//         .ns-pdf-root .contact strong { font-size:0.92rem; }
//         .ns-pdf-root .small { font-size:0.73rem; color:#5B677A; }
//         .ns-pdf-root .light { color:rgba(255,255,255,.66); }
//       `}</style>

//       <div className="ns-pdf-root">
//         <main className="report">

//           {/* ══════════════════════════════════════════
//               PAGE 1 — COVER
//           ══════════════════════════════════════════ */}
//           <section className="ns-page cover">
//             <div style={{ background: `linear-gradient(135deg,${T.navy},${T.blue} 55%,${T.teal})`, minHeight: "1556px", position: "relative" }}>

//               {/* Logo panel — SVG white wedge + Acumen logo image */}
//               <div className="logo-panel">
//                 <svg
//                   width="100%"
//                   height="100%"
//                   viewBox="0 0 500 250"
//                   style={{ position: "absolute", top: 0, right: 0, zIndex: 0 }}
//                   preserveAspectRatio="none"
//                 >
//                   <path d="M 60,8 L 500,8 L 500,188 L 150,253 Q 120,258 113,229 Z" fill="rgba(0,0,0,0.04)" />
//                   <path d="M 60,4 L 500,4 L 500,184 L 150,249 Q 120,254 113,225 Z" fill="rgba(0,0,0,0.06)" />
//                   <path d="M 60,0 L 500,0 L 500,180 L 150,245 Q 120,250 113,221 Z" fill="white" />
//                 </svg>
//                 <div className="logo-panel-inner">
//                   <img
//                     src={Acumen_25_Years_LOGO}
//                     alt="Acumen Logo"
//                     className="logo-img"
//                   />
//                 </div>
//               </div>

//               <div className="cover-inner">

//                 {/* Brand bar */}
//                 <div className="brand">
//                   <div className="badge">Confidential Individual Report</div>
//                 </div>

//                 {/* Title block */}
//                 <div style={{ display: "flex", flexDirection: "column", justifyContent: "center", flex: 1, alignItems: "stretch", width: "100%" }}>
//                   <div className="cover-title">
//                     <h2>Negotiating Styles Assessment</h2>
//                     <p>
//                       Based on Holley, Jennings &amp; Wolters (8th ed.).Measures your orientation
//                       across five negotiating styles on two underlying dimensions — Assertiveness and
//                       Cooperativeness — which together predict your tendency toward Distributive or
//                       Mutual Gain Bargaining.
//                     </p>
//                   </div>

//                   <div className="cover-grid">
//                     <div className="meta"><span>Participant</span><strong>{participant}</strong></div>
//                     <div className="meta"><span>Assessment Date</span><strong>{assessmentDate}</strong></div>
//                     <div className="meta"><span>Dominant Style</span>
//                       <strong>
//                         {dominantDef ? `${dominantDef.code} — ${dominantDef.label}` : "—"}
//                       </strong>
//                     </div>
//                   </div>

//                   {userInfo.company && (
//                     <div style={{ marginTop: "1rem", background: "rgba(255,255,255,.1)", border: "1px solid rgba(255,255,255,.14)", borderRadius: 14, padding: ".9rem 1rem", display: "inline-flex", gap: "1.5rem", flexWrap: "wrap" }}>
//                       {userInfo.company && <div><span style={{ fontSize: ".72rem", color: "rgba(255,255,255,.65)" }}>Organisation</span><br /><strong style={{ fontSize: ".9rem" }}>{userInfo.company}</strong></div>}
//                       {userInfo.department && <div><span style={{ fontSize: ".72rem", color: "rgba(255,255,255,.65)" }}>Department</span><br /><strong style={{ fontSize: ".9rem" }}>{userInfo.department}</strong></div>}
//                     </div>
//                   )}

//                   <div className="cover-badges">
//                     {["Executive Dashboard", "Pentagon Profile", "Five Negotiating Styles", "A–C Graph", "Report Analysis"].map(b => (
//                       <span key={b} className="cover-badge">{b}</span>
//                     ))}
//                   </div>
//                 </div>

//                 <div className="footer-note">
//                   <div>Based on Holley, Jennings &amp; Wolters, 8th ed.</div>
//                   <div>Scored across five styles: CO · CL · CM · AC · AV</div>
//                 </div>

//               </div>
//             </div>
//           </section>


//           {/* ══════════════════════════════════════════
//               PAGE 2 — EXECUTIVE DASHBOARD
//           ══════════════════════════════════════════ */}
//           <section className="ns-page">
//             <div className="page-inner">
//               <div className="topbar">
//                 <div>
//                   <div className="section-kicker" style={{ color: T.gold }}>Page 2</div>
//                   <h2 className="section-title">Executive Dashboard</h2>
//                 </div>
//                 <div className="small">NS Score Summary · {participant}</div>
//               </div>

//               <p style={{ color: T.slate, fontSize: ".95rem", margin: "0 0 1.25rem" }}>
//                 The Negotiating Styles Self-Assessment measures your orientation across five styles on two dimensions — Assertiveness (drive toward Distributive Bargaining) and Cooperativeness (drive toward Mutual Gain Bargaining).
//               </p>

//               {/* Two columns: Pentagon left, Scores + Bars right */}
//               <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: "1.25rem", marginBottom: "1.25rem" }}>

//                 {/* Left — Pentagon + Score tiles */}
//                 <div className="sub-panel">
//                   <h4>Style Profile — Pentagon</h4>
//                   <PentagonSVG scores={scores} dominantStyles={dominantStyles} />
//                   {/* Legend */}
//                   <div style={{ display: "flex", gap: ".75rem", flexWrap: "wrap", justifyContent: "center", margin: ".5rem 0 .85rem" }}>
//                     {["CO", "CL", "CM", "AC", "AV"].map(code => (
//                       <div key={code} style={{ display: "flex", alignItems: "center", gap: 5, fontSize: ".8rem" }}>
//                         <div style={{ width: 10, height: 10, borderRadius: 2, background: STYLE_COLOR[code] }} />
//                         <span style={{ color: T.ink }}>{code}: <strong style={{ color: STYLE_COLOR[code] }}>{scores[code] ?? "—"}</strong></span>
//                       </div>
//                     ))}
//                   </div>
//                   {/* Score tiles */}
//                   <div className="score-tile-grid">
//                     {stylesForDisplay.map(({ def, score, bandLabel, isDominant }) => (
//                       <div key={def.code} className="score-tile"
//                         style={isDominant ? { border: `2px solid ${STYLE_COLOR[def.code]}`, background: "linear-gradient(180deg,#fffdf0,#fffbea)" } : {}}>
//                         <span style={isDominant ? { color: STYLE_COLOR[def.code] } : {}}>{def.code}</span>
//                         <strong style={{ color: STYLE_COLOR[def.code], fontSize: "1.55rem" }}>{score ?? "—"}</strong>
//                         {isDominant && <div className="band" style={{ color: STYLE_COLOR[def.code] }}>Dominant</div>}
//                       </div>
//                     ))}
//                   </div>
//                 </div>

//                 {/* Right — Bars + Insight */}
//                 <div className="sub-panel" style={{ display: "flex", flexDirection: "column", gap: ".75rem" }}>
//                   <h4>Score Breakdown</h4>
//                   <p style={{ color: T.slate, fontSize: ".82rem", margin: "0 0 .5rem" }}>
//                     Each style scored out of 25 (5 questions × 5-point scale). Band thresholds derived from a national student sample.
//                   </p>
//                   {stylesForDisplay.map(({ def, score, isDominant }) => (
//                     <div className="bar-row" key={def.code}>
//                       <div className={`bar-label${isDominant ? " dominant" : ""}`}
//                         style={isDominant ? { color: STYLE_COLOR[def.code] } : {}}>{def.code} — {def.label}</div>
//                       <div className="track">
//                         <div className="fill" style={{ width: `${Math.min(100, ((score ?? 0) / 25) * 100)}%`, background: isDominant ? STYLE_COLOR[def.code] : T.slate, }} />
//                       </div>
//                       <div className="score-val" style={{ color: isDominant ? STYLE_COLOR[def.code] : T.slate }}>{score ?? "—"}</div>
//                     </div>
//                   ))}

//                   {/* Profile badge */}
//                   <div style={{
//                     background: `linear-gradient(135deg,${T.navy}10,${T.blue}08)`,
//                     border: `1px solid ${T.navy}30`, borderRadius: 12, padding: "10px 12px",
//                   }}>
//                     <div style={{ fontSize: ".72rem", fontWeight: 700, color: T.slate, textTransform: "uppercase", letterSpacing: ".07em" }}>Dominant Style</div>
//                     <div style={{ fontSize: "1.25rem", fontWeight: 700, color: dominantDef ? STYLE_COLOR[dominantDef.code] : T.navy, marginTop: 2 }}>
//                       {dominantDef ? `${dominantDef.code} — ${dominantDef.label}` : "—"}
//                     </div>
//                   </div>

//                   <div className="callout">
//                     <strong>Evaluation insight: </strong>
//                     {insightText || "Your profile reflects a distinct orientation across the five negotiating styles."}
//                   </div>
//                 </div>
//               </div>

//               {/* Assertiveness & Cooperativeness Index cards */}
//               <div className="index-grid">
//                 {[
//                   { title: "Assertiveness Index", obj: assertiveness, tendency: "Distributive Bargaining" },
//                   { title: "Cooperativeness Index", obj: cooperativeness, tendency: "Mutual Gain Bargaining" },
//                 ].map(({ title, obj }) => {
//                   const idx = obj?.index ?? null;
//                   const isPos = (idx ?? 0) >= 0;
//                   return (
//                     <div key={title} className={`index-card ${isPos ? "positive" : "negative"}`}>
//                       <div style={{ display: "flex", justifyContent: "space-between", alignItems: "flex-start", marginBottom: "0rem" }}>
//                         <div>
//                           <div style={{ fontWeight: 700, fontSize: ".97rem", color: T.ink }}>{title}</div>

//                         </div>
//                         <div className="index-value" style={{ color: isPos ? "#16a34a" : "#dc2626" }}>
//                           {idx != null ? (idx > 0 ? `+${idx}` : idx) : "—"}
//                         </div>
//                       </div>
//                       <span className="index-badge" style={{ background: isPos ? "#16a34a" : "#dc2626" }}>
//                         {obj?.band_label ?? "—"}
//                       </span>
//                       {obj?.bargaining_tendency && (
//                         <div style={{ fontSize: ".8rem", color: T.slate, fontStyle: "italic", marginTop: ".4rem" }}>
//                           {obj.bargaining_tendency}
//                         </div>
//                       )}
//                     </div>
//                   );
//                 })}
//               </div>

//               {(assertiveness?.index != null || cooperativeness?.index != null) && (
//                 <div className="callout" style={{ marginTop: "1rem" }}>
//                   <strong>What this means: </strong>
//                   {assertiveness?.index >= 5
//                     ? "You are strongly assertive — you drive toward results and are comfortable leading negotiations. Pair this with cooperativeness to unlock Mutual Gain outcomes."
//                     : assertiveness?.index >= 1
//                       ? "You are moderately to highly assertive — you advocate for your position while remaining open to others. This is a balanced, effective profile."
//                       : assertiveness?.index >= -2
//                         ? "You are moderate to low on assertiveness — you may benefit from building confidence to advocate more directly for your interests in negotiations."
//                         : "You are low on assertiveness — negotiation situations may feel uncomfortable. Developing assertiveness skills will significantly expand your effectiveness."}
//                   {" "}
//                   {cooperativeness?.index >= 9
//                     ? "Your cooperativeness is high — you are strongly oriented toward joint solutions and relationship preservation."
//                     : cooperativeness?.index >= 5
//                       ? "Your cooperativeness is moderate to high — you value the other party's interests alongside your own."
//                       : cooperativeness?.index >= 2
//                         ? "Your cooperativeness is moderate to low — you may benefit from greater focus on the other party's underlying interests."
//                         : "Your cooperativeness is low — consider practising perspective-taking and interest-based negotiation techniques."}
//                 </div>
//               )}

//               {/* Definitions — sourced from the Negotiating Styles Self-Assessment document */}
//               <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: "1.25rem", marginTop: "1.25rem" }}>
//                 <div className="sub-panel">
//                   <h4>What is Assertiveness?</h4>
//                   <p style={{ color: T.slate, fontSize: ".82rem", margin: 0, textAlign: "justify" }}>
//                     Distributive Bargaining approaches negotiation as a win-lose exercise where the gains of one party must come at the expense of the other party. The sole focus of the negotiator is to maximize his/her own outcomes. In the negotiation literature, this orientation is referred to as Assertiveness.
//                   </p>
//                 </div>
//                 <div className="sub-panel">
//                   <h4>What is Cooperativeness?</h4>
//                   <p style={{ color: T.slate, fontSize: ".82rem", margin: 0, textAlign: "justify" }}>
//                     Mutual Gain Bargaining approaches negotiation as a mutual problem-solving exercise. Relying on open communication, trust, and mutual respect, negotiators focus on fulfilling the mutual interests of both parties. In the negotiation literature, this orientation is referred to as Cooperativeness.
//                   </p>
//                 </div>
//               </div>
//               <p style={{ color: T.slate, fontSize: ".82rem", fontStyle: "italic", marginTop: ".75rem" }}>
//                 Negotiators that exhibit Assertiveness tendencies are more likely to engage in Distributive Bargaining behavior, while negotiators that are high in Cooperativeness are more likely to use a Mutual Gain Bargaining approach.
//               </p>

//             </div>
//           </section>


//           {/* ══════════════════════════════════════════
//               PAGE 3 — A–C GRAPH
//           ══════════════════════════════════════════ */}
//           <section className="ns-page">
//             <div className="page-inner">
//               <div className="topbar">
//                 <div>
//                   <div className="section-kicker" style={{ color: T.gold }}>Page 3</div>
//                   <h2 className="section-title">Assertiveness &amp; Cooperativeness Graph</h2>
//                 </div>
//                 <div className="small">Distributive vs Mutual Gain</div>
//               </div>

//               <p style={{ color: T.slate, fontSize: ".88rem", margin: "0 0 1.25rem", lineHeight: 1.7 }}>
//                 This graph visually maps your negotiation orientation using your Assertiveness and Cooperativeness indexes. Your plotted position reflects whether your style aligns more closely with Competing, Collaborating, Avoiding, Accommodating, or Compromising behaviour.
//               </p>

//               <div style={{ background: "#fbfdff", border: "1px solid #DCE5EF", borderRadius: 18, padding: "1.25rem", marginBottom: "1.25rem" }}>
//                 <TwoDGraphSVG
//                   assertivenessIndex={assertiveness?.index}
//                   cooperativenessIndex={cooperativeness?.index}
//                 />
//               </div>

//               {/* Index summary below graph */}
//               <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: "1rem" }}>
//                 <div className="card">
//                   <h3>Reading Your Position</h3>
//                   <p className="lead">
//                     The X-axis represents your Cooperativeness index (left = low, right = high). The Y-axis represents your Assertiveness index (down = low, up = high). The centre area marks the Compromising zone — the intersection of moderate assertiveness and cooperativeness.
//                   </p>
//                 </div>
//                 <div className="card">
//                   <h3>Your Indexes</h3>
//                   <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: ".75rem", marginTop: ".4rem" }}>
//                     {[
//                       { label: "Assertiveness", obj: assertiveness },
//                       { label: "Cooperativeness", obj: cooperativeness },
//                     ].map(({ label, obj }) => {
//                       const idx = obj?.index ?? null;
//                       const isPos = (idx ?? 0) >= 0;
//                       return (
//                         <div key={label} style={{ padding: ".75rem", borderRadius: 12, border: `1px solid ${isPos ? "#86efac" : "#fca5a5"}`, background: isPos ? "#f0fff4" : "#fff0f0" }}>
//                           <div style={{ fontSize: ".75rem", color: T.slate, fontWeight: 700, textTransform: "uppercase", letterSpacing: ".07em" }}>{label}</div>
//                           <div style={{ fontSize: "1.8rem", fontWeight: 700, color: isPos ? "#16a34a" : "#dc2626", lineHeight: 1.1, marginTop: ".2rem" }}>
//                             {idx != null ? (idx > 0 ? `+${idx}` : idx) : "—"}
//                           </div>
//                           <div style={{ fontSize: ".75rem", fontWeight: 700, color: isPos ? "#16a34a" : "#dc2626", marginTop: ".3rem" }}>
//                             {obj?.band_label ?? "—"}
//                           </div>
//                         </div>
//                       );
//                     })}
//                   </div>
//                 </div>
//               </div>
//             </div>
//           </section>
//           {/* ══════════════════════════════════════════
//               PAGE 4 — THE FIVE NEGOTIATING STYLES
//           ══════════════════════════════════════════ */}
//           <section className="ns-page">
//             <div className="page-inner">
//               <div className="topbar">
//                 <div>
//                   <div className="section-kicker" style={{ color: T.gold }}>Page 4</div>
//                   <h2 className="section-title">The Five Negotiating Styles</h2>
//                 </div>
//                 <div className="small">CO · CL · CM · AC · AV</div>
//               </div>

//               <p style={{ color: T.slate, fontSize: ".88rem", margin: "0 0 1.1rem" }}>
//                 Each style reflects a distinct combination of Assertiveness and Cooperativeness. Your dominant style is highlighted below.
//               </p>

//               {stylesForDisplaySorted.slice(0, 3).map(({ def, score, bandLabel, isDominant }) => {
//                 const color = STYLE_COLOR[def.code];
//                 return (
//                   <div key={def.code} className={`profile-card${isDominant ? " active" : ""}`}
//                     style={isDominant ? { borderColor: color } : {}}>
//                     <div className="profile-header">
//                       <div className="profile-dot" style={{ background: isDominant ? color : T.line }} />
//                       <div className="profile-meta">
//                         <strong style={{ color: isDominant ? color : T.ink }}>
//                           {def.code} — {def.label}
//                           {isDominant && <span className="your-tag" style={{ background: color }}>★ Dominant</span>}
//                         </strong>
//                         <em>{def.tagline}</em>
//                         <div className="thresholds">Score: {score ?? "—"} / 25 · Band: {bandLabel}</div>
//                       </div>
//                       <div style={{ marginLeft: "auto", textAlign: "center" }}>
//                         <div style={{ fontSize: "1.6rem", fontWeight: 700, color: STYLE_COLOR[def.code] }}>{score ?? "—"}</div>
//                         <div style={{ fontSize: ".7rem", fontWeight: 700, background: `${color}18`, border: `1px solid ${color}40`, borderRadius: 999, padding: "2px 8px", color, marginTop: ".25rem", whiteSpace: "nowrap" }}>{bandLabel}</div>
//                       </div>
//                     </div>

//                     {/* Dimension badges */}
//                     <div style={{ marginBottom: ".5rem" }}>
//                       {[
//                         `Assertiveness: ${def.assertiveness}`,
//                         `Cooperativeness: ${def.cooperativeness}`,
//                         def.bargaining,
//                       ].map(b => (
//                         <span key={b} className="dim-badge"
//                           style={{ background: `${color}14`, border: `1px solid ${color}40`, color }}>
//                           {b}
//                         </span>
//                       ))}
//                     </div>

//                     <p>{def.overview}</p>
//                     {def.orgNote && <p style={{ color: T.slate, fontStyle: "italic",paddingBottom: ".5rem" }}>{def.orgNote}</p>}

//                     {/* Active band only */}
//                     {(() => {
//                       const range = BAND_RANGES[def.code]?.[bandLabel] ?? "";
//                       const desc = BAND_DESCRIPTIONS[def.code]?.[bandLabel] ?? "";
//                       return (
//                         <div className="band-section active-band" style={{ border: `1px solid ${color}40`, background: `${color}08`, marginBottom: ".75rem" }}>
//                           <div style={{ fontWeight: 700, fontSize: ".8rem", color, marginBottom: ".25rem" }}>
//                             {bandLabel}
//                             <span style={{ marginLeft: 8, fontSize: ".68rem", background: color, color: "#fff", borderRadius: 999, padding: "1px 7px" }}>
//                               Your band
//                             </span>
//                           </div>
//                           <p style={{ margin: 0, fontSize: ".83rem", lineHeight: 1.6, color: T.ink }}>{desc}</p>
//                         </div>
//                       );
//                     })()}

//                     <div>
//                       <strong style={{ fontSize: ".85rem", color: T.navy }}>Action steps:</strong>
//                       <ul style={{ marginTop: ".35rem", paddingLeft: "18px", marginBottom: 0, }}>
//                         {def.toDo.map((item, i) => (
//                           <li key={i} style={{ marginBottom: ".3rem", color: T.ink, fontSize: ".83rem", lineHeight: 1.6 }}>{item}</li>
//                         ))}
//                       </ul>
//                     </div>
//                   </div>
//                 );
//               })}
//             </div>
//           </section>
//           {/* ══════════════════════════════════════════
//               PAGE 5 — THE FIVE NEGOTIATING STYLES
//           ══════════════════════════════════════════ */}
//           <section className="ns-page">
//             <div className="page-inner">
//               <div className="topbar">
//                 <div>
//                   <div className="section-kicker" style={{ color: T.gold }}>Page 5</div>
//                   <h2 className="section-title">The Five Negotiating Styles</h2>
//                 </div>
//                 <div className="small">CO · CL · CM · AC · AV</div>
//               </div>

//               <p style={{ color: T.slate, fontSize: ".88rem", margin: "0 0 1.1rem" }}>
//                 Each style reflects a distinct combination of Assertiveness and Cooperativeness. Your dominant style is highlighted below.
//               </p>

//               {stylesForDisplaySorted.slice(3).map(({ def, score, bandLabel, isDominant }) => {
//                 const color = STYLE_COLOR[def.code];
//                 return (
//                   <div key={def.code} className={`profile-card${isDominant ? " active" : ""}`}
//                     style={isDominant ? { borderColor: color } : {}}>
//                     <div className="profile-header">
//                       <div className="profile-dot" style={{ background: isDominant ? color : T.line }} />
//                       <div className="profile-meta">
//                         <strong style={{ color: isDominant ? color : T.ink }}>
//                           {def.code} — {def.label}
//                           {isDominant && <span className="your-tag" style={{ background: color }}>★ Dominant</span>}
//                         </strong>
//                         <em>{def.tagline}</em>
//                         <div className="thresholds">Score: {score ?? "—"} / 25 · Band: {bandLabel}</div>
//                       </div>
//                       <div style={{ marginLeft: "auto", textAlign: "center" }}>
//                         <div style={{ fontSize: "1.6rem", fontWeight: 700, color: STYLE_COLOR[def.code] }}>{score ?? "—"}</div>
//                         <div style={{ fontSize: ".7rem", fontWeight: 700, background: `${color}18`, border: `1px solid ${color}40`, borderRadius: 999, padding: "2px 8px", color, marginTop: ".25rem", whiteSpace: "nowrap" }}>{bandLabel}</div>
//                       </div>
//                     </div>

//                     {/* Dimension badges */}
//                     <div style={{ marginBottom: ".5rem" }}>
//                       {[
//                         `Assertiveness: ${def.assertiveness}`,
//                         `Cooperativeness: ${def.cooperativeness}`,
//                         def.bargaining,
//                       ].map(b => (
//                         <span key={b} className="dim-badge"
//                           style={{ background: `${color}14`, border: `1px solid ${color}40`, color }}>
//                           {b}
//                         </span>
//                       ))}
//                     </div>

//                     <p>{def.overview}</p>
//                     {def.orgNote && <p style={{ color: T.slate, fontStyle: "italic", paddingBottom: ".5rem" }}>{def.orgNote}</p>}

//                     {/* Active band only */}
//                     {(() => {
//                       const range = BAND_RANGES[def.code]?.[bandLabel] ?? "";
//                       const desc = BAND_DESCRIPTIONS[def.code]?.[bandLabel] ?? "";
//                       return (
//                         <div className="band-section active-band" style={{ border: `1px solid ${color}40`, background: `${color}08`, marginBottom: ".75rem" }}>
//                           <div style={{ fontWeight: 700, fontSize: ".8rem", color, marginBottom: ".25rem" }}>
//                             {bandLabel}
//                             <span style={{ marginLeft: 8, fontSize: ".68rem", background: color, color: "#fff", borderRadius: 999, padding: "1px 7px" }}>
//                               Your band
//                             </span>
//                           </div>
//                           <p style={{ margin: 0, fontSize: ".83rem", lineHeight: 1.6, color: T.ink }}>{desc}</p>
//                         </div>
//                       );
//                     })()}

//                     <div>
//                       <strong style={{ fontSize: ".85rem", color: T.navy, marginBottom: ".25rem" }}>Action steps:</strong>
//                       <ul style={{ marginTop: ".35rem", paddingLeft: "18px" }}>
//                         {def.toDo.map((item, i) => (
//                           <li key={i} style={{ marginBottom: ".3rem", color: T.ink, fontSize: ".83rem", lineHeight: 1.6 }}>{item}</li>
//                         ))}
//                       </ul>
//                     </div>
//                   </div>
//                 );
//               })}
//             </div>
//           </section>

//           {/* ══════════════════════════════════════════
//               BACK COVER
//           ══════════════════════════════════════════ */}
//           <section className="ns-page back-cover">
//             <div style={{ background: `linear-gradient(135deg,${T.navy} 0%,#C4163A 50%,${T.teal} 100%)`, minHeight: "1556px" }}>
//               <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", padding: "1.5rem 2.5rem", borderBottom: "1px solid rgba(255,255,255,0.15)" }}>
//                 <div style={{ fontSize: "0.72rem", textTransform: "uppercase", letterSpacing: ".12em", fontWeight: 700, color: "rgba(255,255,255,0.66)" }}>
//                   {/* Back Cover */}
//                 </div>
//                 <div style={{ fontSize: "0.72rem", color: "rgba(255,255,255,0.5)", letterSpacing: ".05em" }}>Acumen Business Catalyst</div>
//               </div>
//               <div className="page-inner">
//                 <div style={{ display: "flex", flexDirection: "column", justifyContent: "center", flex: 1 }}>
//                   <div className="closing">
//                     <h2>Developing Your Negotiating Effectiveness</h2>
//                     <p>
//                       Negotiating style is a dynamic capability, not a fixed trait. Awareness of your
//                       dominant orientation — and the conditions under which it serves or limits you — is
//                       the foundation of deliberate development. Acumen Business Catalyst uses assessments
//                       like this to turn behavioural data into focused conversations that build lasting
//                       negotiating competence.
//                     </p>
//                   </div>
//                 </div>
//                 <div>
//                   <div className="contact-grid">
//                     <div className="contact">
//                       <span>Brand</span>
//                       <strong>Acumen Business Catalyst</strong>
//                     </div>
//                     <div className="contact">
//                       <span>Focus</span>
//                       <strong>Leadership • Culture • Capability</strong>
//                     </div>
//                     <div className="contact">
//                       <span>Report type</span>
//                       <strong>Individual Negotiating Style Profile</strong>
//                     </div>
//                   </div>
//                   <p className="light" style={{ marginTop: "1.5rem", fontSize: "0.75rem" }}>
//                     This report is generated from the Negotiating Styles Self-Assessment framework. Based on Holley, Jennings &amp; Wolters, 8th ed. © 2026 Acumen Business Catalyst.
//                   </p>
//                 </div>
//               </div>
//             </div>
//           </section>

//         </main>
//       </div>
//     </div>
//   );
// }


import React, { useEffect, useRef } from "react";
import Acumen_25_Years_LOGO from "../assets/Acumen_25_Years_LOGO.png";

// ─── DESIGN TOKENS ────────────────────────────────────────────────────────────
const T = {
  navy: "#A80D2C",
  blue: "#C4163A",
  teal: "#7B0F2B",
  gold: "#D79A1E",
  slate: "#5B677A",
  bg: "#F5F8FC",
  card: "#FFFFFF",
  line: "#DCE5EF",
  ink: "#1D2733",
  orange: "#F97316",
};

const STYLE_COLOR = {
  CO: T.navy,
  CL: "#1A7A4A",
  CM: T.gold,
  AC: "#5B4A8A",
  AV: T.orange,
};

// ─── STATIC LOOKUP TABLES (mirrored from NSResult.jsx) ───────────────────────
const NS_DEFINITIONS = [
  {
    code: "CO", key: "competing", label: "Competing",
    tagline: '"I focus on the bottom line and expect to win."',
    assertiveness: "High", cooperativeness: "Low", bargaining: "Distributive Bargaining",
    overview: "Negotiators with this style are results-oriented, self-confident, and assertive. They are focused primarily on the bottom line, tend to impose their views on the other party, and in the extreme can become aggressive and domineering.",
    orgNote: "Competing is effective when quick, decisive action is needed or when you must stand firm on non-negotiable principles. Overuse, however, can damage relationships and reduce the quality of long-term outcomes. Pairing assertiveness with a degree of openness produces better results in recurring negotiations.",
    toDo: [
      "Recognise that winning every battle can mean losing the war — long-term relationships matter.",
      "Practise listening actively to the other party's position before staking your own.",
      "Reserve a hard-competing stance for situations where the outcome is truly non-negotiable.",
      // "Explore whether Collaborating can achieve the same result while preserving the relationship.",
    ],
  },
  {
    code: "CL", key: "collaborating", label: "Collaborating",
    tagline: '"Let\'s find a solution that works for both of us."',
    assertiveness: "High", cooperativeness: "High", bargaining: "Mutual Gain Bargaining",
    overview: "Negotiators with this style use open and honest communication, focus on finding creative solutions that mutually satisfy both parties, are open to exploring new and novel solutions, and suggest many alternatives for consideration.",
    orgNote: "Collaborating is the gold standard for complex, long-term negotiations where relationship quality matters as much as the outcome. It requires trust and transparency from both parties. When the other side is not forthcoming, collaborators must be careful not to be exploited.",
    toDo: [
      "Continue investing in relationship-building before and during negotiations.",
      "Prepare thoroughly — understanding the other party's interests is the foundation of joint solutions.",
      "Be alert to situations where the other party is not collaborating in good faith.",
      // "Share information openly, but verify that reciprocal transparency is present.",
    ],
  },
  {
    code: "CM", key: "compromising", label: "Compromising",
    tagline: '"Let\'s meet halfway and both walk away satisfied."',
    assertiveness: "Moderate", cooperativeness: "Moderate", bargaining: "Mixed",
    overview: "Negotiators with this style aim to find the middle ground, often split the difference between positions, frequently engage in give-and-take tradeoffs, and accept moderate satisfaction of both parties' needs.",
    orgNote: "Compromising is pragmatic and time-efficient. It works well when both parties have equal power and a quick resolution is preferable to a prolonged negotiation. It may, however, leave value on the table that a collaborative approach would have captured.",
    toDo: [
      "Ask whether splitting the difference is truly optimal or simply expedient.",
      "Explore whether a creative trade on different issues could yield more for both sides.",
      "Use compromising as a fallback when collaboration stalls, not as a first resort.",
      // "Track the pattern — if you always compromise, the other party may anchor aggressively.",
    ],
  },
  {
    code: "AC", key: "accommodating", label: "Accommodating",
    tagline: '"I value the relationship above my own outcome."',
    assertiveness: "Low", cooperativeness: "High", bargaining: "Mutual Gain Bargaining",
    overview: "Negotiators with this style make attempts to maintain relationships with the other party, smooth over conflicts, downplay differences, and are most concerned with satisfying the needs of the other party.",
    orgNote: "Accommodating builds goodwill and can preserve important relationships, particularly when the issue at hand matters more to the other party. Chronically accommodating, however, leads to cumulative disadvantage and can signal weakness to strategic negotiators.",
    toDo: [
      "Distinguish between genuine accommodation (strategic relationship investment) and habitual yielding.",
      "Assert your core interests clearly before conceding on secondary points.",
      "Practise saying 'I need to think about that' rather than agreeing immediately.",
      // "Balance relationship focus with outcome focus — your needs matter too.",
    ],
  },
  {
    code: "AV", key: "avoiding", label: "Avoiding",
    tagline: '"I prefer to step back rather than engage in conflict."',
    assertiveness: "Low", cooperativeness: "Low", bargaining: "Neither",
    overview: "Negotiators with this style are passive, prefer to avoid conflict, make attempts to withdraw from the situation or pass responsibility onto another party, and fail to show adequate concern or make an honest attempt to get to a solution.",
    orgNote: "Avoidance has a narrow legitimate application — deferring a trivial issue or a highly charged moment when emotions need to cool. Systematic avoidance, however, means unresolved issues accumulate and others fill the negotiating vacuum, often at your expense.",
    toDo: [
      "Identify which negotiations you are avoiding and ask what the cost of continued avoidance is.",
      "Develop a simple opening script to step into difficult conversations with calm authority.",
      "Distinguish between strategic timing (deferring wisely) and fear-driven withdrawal.",
      // "Seek low-stakes practice negotiations to build comfort and confidence.",
    ],
  },
];

const STYLE_BANDS = {
  CO: { high: 18, mod_to_high: 16, mod_to_low: 14 },
  AV: { high: 18, mod_to_high: 16, mod_to_low: 14 },
  CL: { high: 21, mod_to_high: 19, mod_to_low: 17 },
  AC: { high: 19, mod_to_high: 17, mod_to_low: 15 },
  CM: { high: 20, mod_to_high: 18, mod_to_low: 16 },
};

const BAND_RANGES = {
  CO: { High: "18 or above", "Moderate to High": "16–17", "Moderate to Low": "14–15", Low: "13 or below" },
  AV: { High: "18 or above", "Moderate to High": "16–17", "Moderate to Low": "14–15", Low: "13 or below" },
  CL: { High: "21 or above", "Moderate to High": "19–20", "Moderate to Low": "17–18", Low: "16 or below" },
  AC: { High: "19 or above", "Moderate to High": "17–18", "Moderate to Low": "15–16", Low: "14 or below" },
  CM: { High: "20 or above", "Moderate to High": "18–19", "Moderate to Low": "16–17", Low: "15 or below" },
};

const BAND_DESCRIPTIONS = {
  CO: {
    High: "You strongly exhibit Competing characteristics — results-oriented, self-confident, assertive, and focused on the bottom line. In the extreme this can appear aggressive. You are most aligned with Distributive Bargaining.",
    "Moderate to High": "You moderately to strongly exhibit Competing characteristics. You advocate firmly for your position while retaining some openness to the other party.",
    "Moderate to Low": "You exhibit mild Competing characteristics. You can assert yourself when necessary but generally prefer a less confrontational stance.",
    Low: "You only weakly exhibit Competing characteristics. You are unlikely to use aggressive tactics or hard-positional bargaining.",
  },
  CL: {
    High: "You strongly exhibit Collaborating characteristics — open communication, creativity, and a drive for joint solutions that satisfy both parties. This is the gold standard for Mutual Gain negotiations.",
    "Moderate to High": "You moderately to strongly exhibit Collaborating characteristics. You seek win-win outcomes and invest in understanding the other party's interests.",
    "Moderate to Low": "You exhibit mild Collaborating characteristics. You are open to joint problem-solving but may default to other styles under pressure.",
    Low: "You only weakly exhibit Collaborating characteristics. You tend to approach negotiations as more distributive rather than joint problem-solving.",
  },
  CM: {
    High: "You strongly exhibit Compromising characteristics — you naturally seek the middle ground, engage in give-and-take, and accept partial satisfaction as a fair outcome.",
    "Moderate to High": "You moderately to strongly exhibit Compromising characteristics. You are pragmatic and tend to resolve deadlocks efficiently through mutual concession.",
    "Moderate to Low": "You exhibit mild Compromising characteristics. You will split the difference when necessary but prefer to hold out for a better outcome.",
    Low: "You only weakly exhibit Compromising characteristics. You tend to pursue full satisfaction rather than splitting the difference.",
  },
  AC: {
    High: "You strongly exhibit Accommodating characteristics — you prioritise the relationship, smooth over conflict, and are most concerned with satisfying the other party's needs.",
    "Moderate to High": "You moderately to strongly exhibit Accommodating characteristics. You are relationship-focused and generous in concessions, especially when you value the other party.",
    "Moderate to Low": "You exhibit mild Accommodating characteristics. You balance relationship maintenance with the pursuit of your own interests.",
    Low: "You only weakly exhibit Accommodating characteristics. You rarely yield for relationship reasons alone.",
  },
  AV: {
    High: "You strongly exhibit Avoiding characteristics — you prefer to sidestep conflict, withdraw from negotiations, or pass responsibility rather than engage directly.",
    "Moderate to High": "You moderately to strongly exhibit Avoiding characteristics. You may defer or delay negotiations and prefer others take the lead in conflict situations.",
    "Moderate to Low": "You exhibit mild Avoiding characteristics. You occasionally step back from negotiations but can engage when necessary.",
    Low: "You only weakly exhibit Avoiding characteristics. You are generally comfortable engaging in negotiations and conflict situations.",
  },
};

const INDEX_BAND_ORDER = ["Low", "Moderate to Low", "Moderate to High", "High"];
const INDEX_BAND_COLOR = {
  Low: "#dc2626",
  "Moderate to Low": "#f97316",
  "Moderate to High": "#65a30d",
  High: "#16a34a",
};
const INDEX_DESCRIPTIONS = {
  assertiveness: {
    Low: "A low score means you're less inclined to push for your own outcomes — leaning toward Mutual Gain Bargaining (problem-solving) rather than Distributive Bargaining.",
    "Moderate to Low": "A moderate-to-low score means you assert yourself only occasionally, generally preferring a less confrontational approach.",
    "Moderate to High": "A moderate-to-high score means you readily advocate for your own outcomes while remaining open to the other party's position.",
    High: "A high score means you strongly push for your own outcomes — leaning toward Distributive Bargaining (win-lose) rather than Mutual Gain Bargaining.",
  },
  cooperativeness: {
    Low: "A low score means you're less inclined to prioritize the other party's interests — leaning toward Distributive Bargaining (win-lose) rather than Mutual Gain Bargaining.",
    "Moderate to Low": "A moderate-to-low score means you occasionally consider the other party's interests but tend to focus mainly on your own.",
    "Moderate to High": "A moderate-to-high score means you generally prioritize the other party's interests alongside your own, favouring joint solutions.",
    High: "A high score means you strongly prioritize the other party's interests — leaning toward Mutual Gain Bargaining (problem-solving) rather than Distributive Bargaining.",
  },
};

function getStyleBandLabel(code, score) {
  const b = STYLE_BANDS[code];
  if (!b || score == null) return "—";
  if (score >= b.high) return "High";
  if (score >= b.mod_to_high) return "Moderate to High";
  if (score >= b.mod_to_low) return "Moderate to Low";
  return "Low";
}

function formatDate(date) {
  return date.toLocaleDateString("en-GB", { day: "numeric", month: "long", year: "numeric" });
}

// ─── PENTAGON SVG ─────────────────────────────────────────────────────────────
function PentagonSVG({ scores, dominantStyles }) {
  const cx = 190, cy = 210, maxR = 130, size = 400;
  const order = ["CL", "CO", "CM", "AV", "AC"];
  const MAX_SCORE = 25;
  const n = order.length;

  function angle(i) { return (i * 360) / n - 90; }
  function polar(deg, r) {
    const rad = (deg * Math.PI) / 180;
    return { x: cx + r * Math.cos(rad), y: cy + r * Math.sin(rad) };
  }

  const rings = [5, 10, 15, 20, 25];
  const vertices = order.map((_, i) => polar(angle(i), maxR));

  const scorePoints = order.map((code, i) => {
    const r = ((scores?.[code] ?? 0) / MAX_SCORE) * maxR;
    return polar(angle(i), Math.max(r, 2));
  });
  const polyStr = scorePoints.map(p => `${p.x.toFixed(1)},${p.y.toFixed(1)}`).join(" ");

  return (
    <svg viewBox={`0 0 ${size} ${size}`} width={size} height={size} style={{ display: "block", margin: "0 auto", overflow: "visible" }}>
      {/* Grid rings */}
      {rings.map(v => {
        const pts = order.map((_, i) => polar(angle(i), (v / MAX_SCORE) * maxR));
        return (
          <polygon key={v}
            points={pts.map(p => `${p.x.toFixed(1)},${p.y.toFixed(1)}`).join(" ")}
            fill="none" stroke="#DCE5EF" strokeWidth={1}
          />
        );
      })}
      {/* Ring labels */}
      {rings.map(v => {
        const pt = polar(-90, (v / MAX_SCORE) * maxR);
        return (
          <text key={`rl-${v}`} x={pt.x + 4} y={pt.y} fontSize="9" fill={T.slate} dominantBaseline="middle"
            style={{ fontFamily: "Arial, sans-serif" }}>{v}</text>
        );
      })}
      {/* Axes */}
      {vertices.map((pt, i) => (
        <line key={i} x1={cx} y1={cy} x2={pt.x} y2={pt.y} stroke="#DCE5EF" strokeWidth={1} />
      ))}
      {/* Score polygon */}
      <polygon points={polyStr} fill={`${T.navy}22`} stroke={T.navy} strokeWidth={2} strokeLinejoin="round" />
      {/* Score dots */}
      {scorePoints.map((pt, i) => {
        const code = order[i];
        const isDom = dominantStyles?.includes(code);
        return (
          <circle key={i} cx={pt.x} cy={pt.y} r={6}
            fill={isDom ? STYLE_COLOR[code] : "#fff"}
            stroke={STYLE_COLOR[code]} strokeWidth={2.5}
          />
        );
      })}
      {/* Axis labels */}
      {order.map((code, i) => {
        const LABEL_R = maxR + 30;
        const pt = polar(angle(i), LABEL_R);
        const isDom = dominantStyles?.includes(code);
        const def = NS_DEFINITIONS.find(d => d.code === code);
        return (
          <g key={code}>
            <text x={pt.x} y={pt.y - 8} textAnchor="middle" dominantBaseline="middle"
              fontSize="13" fontWeight="700" fill={isDom ? STYLE_COLOR[code] : T.ink}
              style={{ fontFamily: "Arial, sans-serif" }}>
              {code}
            </text>
            <text x={pt.x} y={pt.y + 10} textAnchor="middle" dominantBaseline="middle"
              fontSize="10" fill={T.slate} style={{ fontFamily: "Arial, sans-serif" }}>
              {def?.label}
            </text>
          </g>
        );
      })}
      {/* Centre label */}
      <text x={cx} y={cy - 10} textAnchor="middle" fontSize="11" fill={T.slate} fontWeight="600"
        style={{ fontFamily: "Arial, sans-serif" }}>STYLE</text>
      <text x={cx} y={cy + 10} textAnchor="middle" fontSize="11" fill={T.slate} fontWeight="600"
        style={{ fontFamily: "Arial, sans-serif" }}>PROFILE</text>
    </svg>
  );
}

// ─── 2D ASSERTIVENESS / COOPERATIVENESS SVG ───────────────────────────────────
// Mirrors the Figure 1 diagram from the self-assessment: both axes are split into
// 4 qualitative bands (Low / Moderate to Low / Moderate to High / High) with no
// numbers shown — matching the official interpretation-guide bandings exactly.
function TwoDGraphSVG({ assertivenessIndex, cooperativenessIndex }) {
  const W = 900, H = 680;
  const PAD = { top: 48, right: 48, bottom: 82, left: 138 };
  const GW = W - PAD.left - PAD.right;
  const GH = H - PAD.top - PAD.bottom;

  const BANDS = ["Low", "Moderate to Low", "Moderate to High", "High"];

  // Breakpoints map the raw index onto a continuous 0–4 scale across the 4 bands,
  // using the exact cut-offs from the official interpretation tables:
  //   Assertiveness:   Low ≤ -3 | Mod-to-Low -2..0 | Mod-to-High 1..4 | High ≥ 5
  //   Cooperativeness: Low ≤ 1  | Mod-to-Low 2..4  | Mod-to-High 5..8 | High ≥ 9
  const assertBreaks = [-8, -2.5, 0.5, 4.5, 9];
  const coopBreaks = [-3, 1.5, 4.5, 8.5, 13];

  const bandPosition = (value, breaks) => {
    const v = value ?? (breaks[2] + breaks[1]) / 2;
    const clamped = Math.max(breaks[0], Math.min(breaks[4], v));
    for (let i = 0; i < 4; i++) {
      if (clamped <= breaks[i + 1] || i === 3) {
        const segStart = breaks[i], segEnd = breaks[i + 1];
        const frac = segEnd === segStart ? 0.5 : (clamped - segStart) / (segEnd - segStart);
        return i + frac;
      }
    }
    return 2;
  };

  const assertPos = bandPosition(assertivenessIndex, assertBreaks); // 0 (Low) → 4 (High)
  const coopPos = bandPosition(cooperativenessIndex, coopBreaks);

  const cx = PAD.left + (coopPos / 4) * GW;
  const cy = PAD.top + (1 - assertPos / 4) * GH;

  const axisX = PAD.left + 0.5 * GW; // Low/High midline
  const axisY = PAD.top + 0.5 * GH;

  return (
    <svg viewBox={`0 0 ${W} ${H}`} width={W} height={H}
      style={{ display: "block", margin: "0 auto", fontFamily: "Arial, sans-serif" }}>

      {/* Quadrant fills */}
      {/* Competing — top-left */}
      <rect x={PAD.left} y={PAD.top} width={axisX - PAD.left} height={axisY - PAD.top}
        fill="rgba(239,68,68,0.07)" />
      {/* Collaborating — top-right */}
      <rect x={axisX} y={PAD.top} width={W - PAD.right - axisX} height={axisY - PAD.top}
        fill="rgba(34,197,94,0.07)" />
      {/* Avoiding — bottom-left */}
      <rect x={PAD.left} y={axisY} width={axisX - PAD.left} height={H - PAD.bottom - axisY}
        fill="rgba(100,116,139,0.07)" />
      {/* Accommodating — bottom-right */}
      <rect x={axisX} y={axisY} width={W - PAD.right - axisX} height={H - PAD.bottom - axisY}
        fill="rgba(59,130,246,0.07)" />

      {/* Graph border */}
      <rect x={PAD.left} y={PAD.top} width={GW} height={GH}
        fill="none" stroke="#DCE5EF" strokeWidth={1} />

      {/* Band grid lines (dividers between Low / Mod-Low / Mod-High / High) */}
      {[1, 2, 3].map(i => {
        const gx = PAD.left + (i / 4) * GW;
        const gy = PAD.top + (i / 4) * GH;
        return (
          <g key={i}>
            {i !== 2 && <line x1={gx} y1={PAD.top} x2={gx} y2={H - PAD.bottom} stroke="rgba(148,163,184,0.25)" strokeWidth={1} />}
            {i !== 2 && <line x1={PAD.left} y1={gy} x2={W - PAD.right} y2={gy} stroke="rgba(148,163,184,0.25)" strokeWidth={1} />}
          </g>
        );
      })}

      {/* Compromising — dashed border around the central 4 grid cells */}
      <rect x={PAD.left + 0.25 * GW} y={PAD.top + 0.25 * GH} width={0.5 * GW} height={0.5 * GH}
        fill="rgba(234,179,8,0.10)" stroke="rgba(202,138,4,0.6)" strokeWidth={2}
        strokeDasharray="6 4" />

      {/* Center axes */}
      <line x1={axisX} y1={PAD.top} x2={axisX} y2={H - PAD.bottom} stroke="#94a3b8" strokeWidth={2} />
      <line x1={PAD.left} y1={axisY} x2={W - PAD.right} y2={axisY} stroke="#94a3b8" strokeWidth={2} />

      {/* Y-axis band labels (assertiveness) */}
      {BANDS.map((label, i) => {
        const gy = PAD.top + (1 - (i + 0.5) / 4) * GH;
        return (
          <text key={`y-${label}`} x={PAD.left - 10} y={gy} fontSize="10.5" fill="#475569" fontWeight="700"
            textAnchor="end" dominantBaseline="middle">{label}</text>
        );
      })}

      {/* X-axis band labels (cooperativeness) */}
      {BANDS.map((label, i) => {
        const gx = PAD.left + ((i + 0.5) / 4) * GW;
        return (
          <text key={`x-${label}`} x={gx} y={H - PAD.bottom + 20} fontSize="10.5" fill="#475569" fontWeight="700"
            textAnchor="middle">{label}</text>
        );
      })}

      {/* Quadrant labels */}
      <text x={PAD.left + 18} y={PAD.top + 36} fontSize="16" fontWeight="800" fill="#dc2626">Competing</text>
      <text x={W - PAD.right - 18} y={PAD.top + 36} fontSize="16" fontWeight="800" fill="#16a34a" textAnchor="end">Collaborating</text>
      <text x={PAD.left + 18} y={H - PAD.bottom - 28} fontSize="16" fontWeight="800" fill="#64748b">Avoiding</text>
      <text x={W - PAD.right - 18} y={H - PAD.bottom - 28} fontSize="16" fontWeight="800" fill="#2563eb" textAnchor="end">Accommodating</text>

      {/* Compromising label */}
      <rect x={axisX - 64} y={axisY - 16} width={130} height={32} rx={16}
        fill="#ffffff" stroke="rgba(202,138,4,0.4)" strokeWidth={1.5} />
      <text x={axisX + 1} y={axisY + 5} fontSize="13" fontWeight="800" fill="#ca8a04"
        textAnchor="middle">Compromising</text>

      {/* Axis direction labels */}
      <text x={axisX} y={H - 40} fontSize="13" fontWeight="800" fill={T.ink} textAnchor="middle">Cooperativeness</text>
      <text x={axisX} y={H - 18} fontSize="12" fontStyle="italic" fontWeight="600" fill={T.ink} textAnchor="middle">Mutual Gain Bargaining</text>
      <text x={14} y={H / 2} fontSize="13" fontWeight="800" fill={T.ink}
        textAnchor="middle" transform={`rotate(-90, 14, ${H / 2})`}>Assertiveness</text>
      <text x={32} y={H / 2} fontSize="12" fontStyle="italic" fontWeight="600" fill={T.ink}
        textAnchor="middle" transform={`rotate(-90, 32, ${H / 2})`}>Distributive Bargaining</text>
      <text x={W - 10} y={H / 2} fontSize="13" fontWeight="800" fill={T.ink}
        textAnchor="middle" transform={`rotate(90, ${W - 10}, ${H / 2})`}>High Coop. ►</text>

      {/* User dot */}
      <circle cx={cx} cy={cy} r={14} fill="#7c3aed" stroke="white" strokeWidth={4}
        style={{ filter: "drop-shadow(0 4px 8px rgba(124,58,237,0.4))" }} />
      {/* Tooltip bubble */}
      <rect x={cx - 58} y={cy + 20} width={118} height={30} rx={10}
        fill="#111827" />
      <text x={cx + 1} y={cy + 40} fontSize="12" fontWeight="600" fill="white"
        textAnchor="middle">Your Position</text>
    </svg>
  );
}

// ═══════════════════════════════════════════════════════════════════════════════
export default function HiddenNSReport({ participantData, onComplete }) {
  const containerRef = useRef(null);
  const hasGenerated = useRef(false);

  // ── Load html2canvas + jsPDF once ─────────────────────────────────────────
  useEffect(() => {
    let pending = 2;
    const done = () => { pending--; };
    const load = (src, id) => {
      if (document.getElementById(id)) { done(); return; }
      const s = document.createElement("script");
      s.id = id; s.src = src; s.onload = done; s.onerror = done;
      document.head.appendChild(s);
    };
    load("https://cdnjs.cloudflare.com/ajax/libs/html2canvas/1.4.1/html2canvas.min.js", "h2c-ns-v1");
    load("https://cdnjs.cloudflare.com/ajax/libs/jspdf/2.5.1/jspdf.umd.min.js", "jspdf-ns-v1");
  }, []);

  // ── Generate PDF whenever participantData is set ──────────────────────────
  useEffect(() => {
    if (!participantData || hasGenerated.current) return;
    hasGenerated.current = true;

    const generate = async () => {
      await new Promise((res) => {
        const check = () => {
          if (window.html2canvas && window.jspdf?.jsPDF) { res(); return; }
          setTimeout(check, 100);
        };
        check();
      });

      await new Promise((r) => setTimeout(r, 1400));

      const el = containerRef.current;
      if (!el) { onComplete?.(); return; }

      try {
        const { jsPDF } = window.jspdf;
        const A4_W = 210, A4_H = 297;

        const pageEls = Array.from(el.querySelectorAll(".ns-page"));
        const pdf = new jsPDF({ unit: "mm", format: "a4", orientation: "portrait" });

        for (let i = 0; i < pageEls.length; i++) {
          const canvas = await window.html2canvas(pageEls[i], {
            scale: 2, useCORS: true, allowTaint: true, logging: false,
            backgroundColor: "#ffffff",
            width: pageEls[i].scrollWidth, height: pageEls[i].scrollHeight,
            windowWidth: pageEls[i].scrollWidth,
          });

          const imgData = canvas.toDataURL("image/jpeg", 0.95);
          const logicalW = canvas.width / 2;
          const logicalH = canvas.height / 2;
          const MM_PER_PX = 25.4 / 96;
          const naturalW = logicalW * MM_PER_PX;
          const naturalH = logicalH * MM_PER_PX;
          const scaleToW = A4_W / naturalW;
          const projectedH = naturalH * scaleToW;

          let imgW, imgH, xOff, yOff;
          if (projectedH <= A4_H) {
            imgW = A4_W; imgH = projectedH; xOff = 0; yOff = 0;
          } else {
            const scaleToH = A4_H / naturalH;
            imgW = naturalW * scaleToH; imgH = A4_H;
            xOff = (A4_W - imgW) / 2; yOff = 0;
          }

          if (i > 0) pdf.addPage();
          pdf.addImage(imgData, "JPEG", xOff, yOff, imgW, imgH);
        }

        const safeName = (participantData.userInfo?.name || "Report").replace(/\s+/g, "_");
        pdf.save(`NS_Report_${safeName}.pdf`);
      } catch (err) {
        console.error("NS PDF generation failed", err);
      } finally {
        hasGenerated.current = false;
        onComplete?.();
      }
    };

    generate();
  }, [participantData]); // eslint-disable-line react-hooks/exhaustive-deps

  if (!participantData) return null;

  // ── Derive display values ──────────────────────────────────────────────────
  const {
    userInfo = {},
    nsData = {},
    scores = {},
    dominantStyles = [],
    insightText = "",
    submission_time,
  } = participantData;

  const participant = userInfo.name || "—";
  const assessmentDate = formatDate(
    submission_time
      ? new Date(submission_time)
      : new Date()
  );
  const assertiveness = nsData?.assertiveness ?? {};
  const cooperativeness = nsData?.cooperativeness ?? {};

  const stylesForDisplay = NS_DEFINITIONS.map(def => {
    const apiStyle = nsData?.styles?.[def.key];
    const score = apiStyle?.score ?? scores[def.code] ?? null;
    const bandLabel = apiStyle?.band_label ?? getStyleBandLabel(def.code, score);
    const isDominant = dominantStyles.includes(def.code);
    return { def, score, bandLabel, isDominant };
  });

  // Sorted highest-score-first — used only for Pages 3 & 4
  const stylesForDisplaySorted = [...stylesForDisplay].sort(
    (a, b) => (b.score ?? -Infinity) - (a.score ?? -Infinity)
  );

  const dominantDef = NS_DEFINITIONS.find(d => dominantStyles.includes(d.code));

  // ── Render ─────────────────────────────────────────────────────────────────
  return (
    <div
      ref={containerRef}
      aria-hidden="true"
      style={{
        position: "fixed", top: "0", left: "-9999px",
        width: "1100px", opacity: 0, pointerEvents: "none", zIndex: -1,
      }}
    >
      <link
        href="https://fonts.googleapis.com/css2?family=Inter:wght@300;400;500;600;700;800;900&display=swap"
        rel="stylesheet"
      />

      {/* ── All CSS scoped under .ns-pdf-root ── */}
      <style>{`
        .ns-pdf-root {
          font-family: 'Inter', Arial, sans-serif;
          background: #F5F8FC;
          color: #1D2733;
          line-height: 1.55;
        }
        .ns-pdf-root .report { max-width:1100px; margin:0 auto; padding:1.5rem 1rem 3rem; }

        /* ── Page shell ── */
        .ns-pdf-root .ns-page {
          background: #ffffff;
          border: 1px solid #DCE5EF;
          border-radius: 24px;
          box-shadow: 0 14px 36px rgba(11,31,58,.10);
          overflow: hidden;
          margin-bottom: 1.5rem;
        }

        /* ── Cover ── */
        .ns-pdf-root .cover { min-height:1556px; position:relative; color:white; }
        .ns-pdf-root .cover-inner { padding:3.5rem; display:flex; flex-direction:column; justify-content:space-between; min-height:1556px; }
        .ns-pdf-root .brand { display:flex; align-items:center; justify-content:space-between; gap:1rem; }
        .ns-pdf-root .brand-left { display:flex; align-items:center; gap:1rem; }
        .ns-pdf-root .logo { width:60px; height:60px; border-radius:16px; display:grid; place-items:center; font-weight:900; font-size:1.1rem; letter-spacing:.06em; flex-shrink:0; }
        .ns-pdf-root .brand h1 { margin:0; font-size:1.2rem; letter-spacing:.07em; text-transform:uppercase; }
        .ns-pdf-root .brand p  { margin:.15rem 0 0; color:rgba(255,255,255,.72); font-size:0.85rem; }
        .ns-pdf-root .badge { border:1px solid rgba(255,255,255,.2); background:rgba(255,255,255,.1); padding:.5rem 1rem; border-radius:999px; font-size:0.76rem; }
        .ns-pdf-root .cover-title h2 {margin:0 0 1rem; font-size:3.4rem;line-height:.95; color:#FFFFFF;white-space:nowrap; max-width:none; border-left: 6px solid #FFFFFF !important; padding-left: 1rem;}
        .ns-pdf-root .cover-title p  { text-align: justify; font-size:1.2rem; color:rgba(255,255,255,.82); max-width:100%; }
        .ns-pdf-root .cover-grid { display:grid; grid-template-columns:repeat(3,1fr); gap:1rem; margin-top:2.5rem; }
        .ns-pdf-root .meta { background:rgba(255,255,255,.1); font-size:1.2rem; border:1px solid rgba(255,255,255,.14); border-radius:16px; padding:.9rem 1rem; }
        .ns-pdf-root .meta span   { display:block; font-size:0.75rem; color:rgba(255,255,255,.65); margin-bottom:.2rem; }
        .ns-pdf-root .meta strong { font-size:0.95rem; color:#FFFFFF; }
        .ns-pdf-root .cover-badges { display:flex; flex-wrap:wrap; gap:.6rem; margin-top:2rem; }
        .ns-pdf-root .cover-badge  { background:rgba(255,255,255,.12); border:1px solid rgba(255,255,255,.18); padding:.5rem .9rem; border-radius:999px; font-size:0.95rem; }
        .ns-pdf-root .footer-note { display:flex; justify-content:space-between; gap:1rem; color:rgba(255,255,255,.68); font-size:0.75rem; margin-top:2rem; }

        .ns-pdf-root .logo-panel {
          position: absolute;
          top: 0;
          right: 0;
          width: 500px;
          height: 250px;
          display: flex;
          align-items: center;
          justify-content: center;
          z-index: 1;
        }
        .ns-pdf-root .logo-panel-inner {
          display: flex;
          flex-direction: column;
          align-items: center;
          position: relative;
          z-index: 2;
          padding-left: 60px;
          padding-bottom: 25px;
        }
        .ns-pdf-root .logo-img { height: 65px; width: auto; object-fit: contain; flex-shrink: 0; }

        /* ── Inner pages ── */
        .ns-pdf-root .page-inner { padding:2.5rem; padding-bottom:0rem; }
        .ns-pdf-root .topbar { display:flex; justify-content:space-between; align-items:flex-start; gap:1rem; margin-bottom:1.75rem; }
        .ns-pdf-root .section-kicker { font-size:0.72rem; text-transform:uppercase; letter-spacing:.12em; font-weight:700; }
        .ns-pdf-root .section-title { margin:.35rem 0 0; font-size:clamp(1.45rem,1.2rem + 1.1vw,2rem); color:#0f2744; border-left: 5px solid #C4163A; padding-left: .75rem; }

        /* ── Cards ── */
        .ns-pdf-root .card { background:#ffffff; border:1px solid #DCE5EF; border-radius:18px; padding:1.25rem; box-shadow:0 4px 14px rgba(16,24,40,.05); }
        .ns-pdf-root .card h3 { margin:0 0 .65rem; font-size:1.05rem; color:#1D2733; }
        .ns-pdf-root .lead { color:#334155; font-size:0.93rem; margin:0; }

        /* ── Sub-panels ── */
        .ns-pdf-root .sub-panel { background:#fbfdff; border:1px solid #DCE5EF; border-radius:14px; padding:1rem; }
        .ns-pdf-root .sub-panel h4 { margin:0 0 .6rem; font-size:.95rem; color:#1D2733; }

        /* ── Score tiles ── */
        .ns-pdf-root .score-tile-grid { display:grid; grid-template-columns:repeat(5,1fr); gap:.6rem; margin-top:.85rem; }
        .ns-pdf-root .score-tile { border-radius:14px; border:1px solid #DCE5EF; padding:.75rem; background:linear-gradient(180deg,#fff,#f8fbff); text-align:center; }
        .ns-pdf-root .score-tile span   { display:block; font-size:0.68rem; letter-spacing:.08em; text-transform:uppercase; color:#5B677A; font-weight:700; margin-bottom:.2rem; }
        .ns-pdf-root .score-tile strong { font-size:1.7rem; color:#A80D2C; font-weight:700; display:block; }
        .ns-pdf-root .score-tile .band  { font-size:0.68rem; font-weight:700; text-transform:uppercase; letter-spacing:.05em; margin-top:.2rem; }

        /* ── Bars ── */
        .ns-pdf-root .bar-row { display:grid; grid-template-columns:200px 1fr 48px; gap:10px; align-items:center; margin-bottom:.65rem; }
        .ns-pdf-root .bar-label { font-size:0.88rem; color:#1D2733; }
        .ns-pdf-root .bar-label.dominant { font-weight:700; }
        .ns-pdf-root .track { height:10px; background:#EAF0F6; border-radius:999px; overflow:hidden; }
        .ns-pdf-root .fill  { height:100%; border-radius:999px; }
        .ns-pdf-root .score-val { text-align:right; font-size:0.85rem; font-weight:700; color:#A80D2C; }

        /* ── Callout ── */
        .ns-pdf-root .callout { background:linear-gradient(180deg,#fff9e8,#fffdf2); border:1px solid #F2D58A; border-radius:14px; padding:.85rem 1rem; font-size:0.88rem; line-height:1.6; }

        /* ── Index cards ── */
        .ns-pdf-root .index-grid { display:grid; grid-template-columns:1fr 1fr; gap:1rem; margin-top:1.25rem; }
        .ns-pdf-root .index-card { border-radius:14px; padding:1rem 1.1rem; }
        .ns-pdf-root .index-card.positive { background:linear-gradient(180deg,#f0fff4,#e8fdf0); border:1px solid #86efac; }
        .ns-pdf-root .index-card.negative { background:linear-gradient(180deg,#fff5f0,#fdeaea); border:1px solid #fca5a5; }
        .ns-pdf-root .index-value { font-size:2.4rem; font-weight:700; line-height:1; }
        .ns-pdf-root .index-badge { border-radius:999px; padding:3px 12px; font-size:.75rem; font-weight:700; color:#fff; display:inline-block; margin-top:.4rem; }

        /* ── Style profile cards ── */
        .ns-pdf-root .profile-card { border:1px solid #DCE5EF; border-radius:16px; padding:1rem; margin-bottom:.25rem; background:#fff; }
        .ns-pdf-root .profile-card.active { box-shadow:0 0 0 2px rgba(168,13,44,.18); }
        .ns-pdf-root .profile-header { display:flex; align-items:center; gap:.85rem; margin-bottom:.3rem; }
        .ns-pdf-root .profile-dot { width:14px; height:14px; border-radius:50%; flex-shrink:0; }
        .ns-pdf-root .profile-badge-circle { width:44px; height:44px; border-radius:50%; flex-shrink:0; display:flex; align-items:center; justify-content:center; color:#fff; font-weight:800; font-size:.85rem; letter-spacing:.02em; }
        .ns-pdf-root .profile-meta strong { display:block; font-size:.97rem; color:#1D2733; }
        .ns-pdf-root .profile-meta em     { font-style:italic; font-size:.82rem; color:#5B677A; }
        .ns-pdf-root .profile-meta .thresholds { font-size:.75rem; color:#5B677A; margin-top:.15rem; }
        .ns-pdf-root .profile-card p { margin:0 0 .2rem; font-size:0.84rem; color:#334155; }
        .ns-pdf-root .your-tag { display:inline-block; font-size:.68rem; font-weight:700; letter-spacing:.03em; margin-left:.5rem; padding:2px 10px; border-radius:999px; color:#fff; vertical-align:middle; text-transform:uppercase; }
        .ns-pdf-root .dim-badge { border-radius:999px; padding:3px 10px; font-size:.75rem; font-weight:600; display:inline-block; margin:.2rem .3rem .2rem 0; }

        /* ── Analysis items ── */
        .ns-pdf-root .analysis-item { border:1px solid #DCE5EF; border-radius:16px; padding:1rem; margin-bottom:.75rem; background:#fff; }
        .ns-pdf-root .analysis-item h4 { margin:0 0 .5rem; font-size:.97rem; }
        .ns-pdf-root .analysis-item p  { margin:0 0 .35rem; font-size:0.84rem; color:#334155; }
        .ns-pdf-root .analysis-item ul { margin:.3rem 0 0; padding-left:18px; font-size:0.84rem; color:#334155; line-height:1.6; }
        .ns-pdf-root .band-section { border-radius:10px; padding:.65rem .85rem; margin-bottom:.5rem; border:1px solid #DCE5EF; background:#f8fbff; }
        .ns-pdf-root .band-section.active-band { background:#fffdf5; }

        /* ── Two-col ── */
        .ns-pdf-root .two-col { display:grid; grid-template-columns:1fr 1fr; gap:1.2rem; }

        /* ── Back cover ── */
        .ns-pdf-root .back-cover { min-height:1556px; color:white; }
        .ns-pdf-root .back-cover .page-inner { min-height:1556px; display:flex; flex-direction:column; justify-content:space-between; }
        .ns-pdf-root .closing h2 { margin:0 0 .85rem; font-size:2.8rem; color:#FFFFFF; border-left: 6px solid #FFFFFF !important; padding-left: 1rem; }
        .ns-pdf-root .closing p  { text-align: justify; max-width: 100%; color:rgba(255,255,255,.82); font-size:1.2rem; }
        .ns-pdf-root .contact-grid { display:grid; grid-template-columns:repeat(3,1fr); gap:1rem; margin-top:1.75rem; }
        .ns-pdf-root .contact { background:rgba(193,24,24,.1); border:1px solid rgba(255,255,255,.16); border-radius:16px; padding:.9rem; }
        .ns-pdf-root .contact span   { display:block; color:rgba(255,255,255,.64); font-size:0.73rem; margin-bottom:.25rem; }
        .ns-pdf-root .contact strong { font-size:0.92rem; }
        .ns-pdf-root .small { font-size:0.73rem; color:#5B677A; }
        .ns-pdf-root .light { color:rgba(255,255,255,.66); }
      `}</style>

      <div className="ns-pdf-root">
        <main className="report">

          {/* ══════════════════════════════════════════
              PAGE 1 — COVER
          ══════════════════════════════════════════ */}
          <section className="ns-page cover">
            <div style={{ background: `linear-gradient(135deg,${T.navy},${T.blue} 55%,${T.teal})`, minHeight: "1556px", position: "relative" }}>

              {/* Logo panel — SVG white wedge + Acumen logo image */}
              <div className="logo-panel">
                <svg
                  width="100%"
                  height="100%"
                  viewBox="0 0 500 250"
                  style={{ position: "absolute", top: 0, right: 0, zIndex: 0 }}
                  preserveAspectRatio="none"
                >
                  <path d="M 60,8 L 500,8 L 500,188 L 150,253 Q 120,258 113,229 Z" fill="rgba(0,0,0,0.04)" />
                  <path d="M 60,4 L 500,4 L 500,184 L 150,249 Q 120,254 113,225 Z" fill="rgba(0,0,0,0.06)" />
                  <path d="M 60,0 L 500,0 L 500,180 L 150,245 Q 120,250 113,221 Z" fill="white" />
                </svg>
                <div className="logo-panel-inner">
                  <img
                    src={Acumen_25_Years_LOGO}
                    alt="Acumen Logo"
                    className="logo-img"
                  />
                </div>
              </div>

              <div className="cover-inner">

                {/* Brand bar */}
                <div className="brand">
                  <div className="badge">Confidential Individual Report</div>
                </div>

                {/* Title block */}
                <div style={{ display: "flex", flexDirection: "column", justifyContent: "center", flex: 1, alignItems: "stretch", width: "100%" }}>
                  <div className="cover-title">
                    <h2>Negotiating Styles Assessment</h2>
                    <p>
                      Based on Holley, Jennings &amp; Wolters (8th ed.).Measures your orientation
                      across five negotiating styles on two underlying dimensions — Assertiveness and
                      Cooperativeness — which together predict your tendency toward Distributive or
                      Mutual Gain Bargaining.
                    </p>
                  </div>

                  <div className="cover-grid">
                    <div className="meta"><span>Participant</span><strong>{participant}</strong></div>
                    <div className="meta"><span>Assessment Date</span><strong>{assessmentDate}</strong></div>
                    <div className="meta"><span>Dominant Style</span>
                      <strong>
                        {dominantDef ? `${dominantDef.code} — ${dominantDef.label}` : "—"}
                      </strong>
                    </div>
                  </div>

                  {userInfo.company && (
                    <div style={{ marginTop: "1rem", background: "rgba(255,255,255,.1)", border: "1px solid rgba(255,255,255,.14)", borderRadius: 14, padding: ".9rem 1rem", display: "inline-flex", gap: "1.5rem", flexWrap: "wrap" }}>
                      {userInfo.company && <div><span style={{ fontSize: ".72rem", color: "rgba(255,255,255,.65)" }}>Organisation</span><br /><strong style={{ fontSize: ".9rem" }}>{userInfo.company}</strong></div>}
                      {userInfo.department && <div><span style={{ fontSize: ".72rem", color: "rgba(255,255,255,.65)" }}>Department</span><br /><strong style={{ fontSize: ".9rem" }}>{userInfo.department}</strong></div>}
                    </div>
                  )}

                  <div className="cover-badges">
                    {["Executive Dashboard", "Pentagon Profile", "Five Negotiating Styles", "A–C Graph", "Report Analysis"].map(b => (
                      <span key={b} className="cover-badge">{b}</span>
                    ))}
                  </div>
                </div>

                <div className="footer-note">
                  <div>Based on Holley, Jennings &amp; Wolters, 8th ed.</div>
                  <div>Scored across five styles: CO · CL · CM · AC · AV</div>
                </div>

              </div>
            </div>
          </section>


          {/* ══════════════════════════════════════════
              PAGE 2 — THE TWO CONCEPTS
          ══════════════════════════════════════════ */}
          <section className="ns-page">
            <div className="page-inner">
              <div className="topbar">
                <div>
                  <div className="section-kicker" style={{ color: T.gold }}>Page 2</div>
                  <h2 className="section-title">The Two Concepts</h2>
                </div>
                <div className="small">Assertiveness &amp; Cooperativeness · {participant}</div>
              </div>

              <p style={{ color: T.slate, fontSize: ".95rem", margin: "0 0 1.25rem" }}>
                The Negotiating Styles Self-Assessment measures your orientation across five styles on two dimensions — Assertiveness (drive toward Distributive Bargaining) and Cooperativeness (drive toward Mutual Gain Bargaining).
              </p>

              {/* Definitions — sourced from the Negotiating Styles Self-Assessment document */}
              <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: "1.25rem" }}>
                <div className="sub-panel">
                  <h4>What is Assertiveness?</h4>
                  <p style={{ color: T.slate, fontSize: ".82rem", margin: "0 0 .75rem", textAlign: "justify" }}>
                    Distributive Bargaining approaches negotiation as a win-lose exercise where the gains of one party must come at the expense of the other party. The sole focus of the negotiator is to maximize his/her own outcomes. In the negotiation literature, this orientation is referred to as Assertiveness.
                  </p>
                  <div style={{ fontSize: ".68rem", fontWeight: 800, letterSpacing: ".05em", textTransform: "uppercase", color: T.navy, marginBottom: "4px" }}>Ask Yourself</div>
                  <p style={{ fontSize: ".78rem", fontStyle: "italic", color: T.ink, margin: "0 0 .6rem" }}>
                    "How strongly am I pursuing what I want?"
                  </p>
                  <div style={{ fontSize: ".68rem", fontWeight: 800, letterSpacing: ".05em", textTransform: "uppercase", color: "#2c8a5e", marginBottom: "4px" }}>Useful When</div>
                  <ul style={{ listStyle: "none", margin: "0 0 .6rem", padding: 0 }}>
                    {["Your objectives are important and non-negotiable", "You need to protect your organisation's interests", "Time is limited, or the negotiation is largely transactional"].map((t) => (
                      <li key={t} style={{ fontSize: ".78rem", lineHeight: 1.55, color: T.slate, paddingLeft: 14, position: "relative", marginBottom: 3 }}>
                        <span style={{ position: "absolute", left: 0 }}>–</span>{t}
                      </li>
                    ))}
                  </ul>
                  <div style={{ fontSize: ".68rem", fontWeight: 800, letterSpacing: ".05em", textTransform: "uppercase", color: "#a5203f", marginBottom: "4px" }}>Caution</div>
                  <p style={{ fontSize: ".78rem", lineHeight: 1.55, color: T.slate, margin: 0 }}>
                    Becomes counterproductive when it turns into aggression, positional bargaining, or "I need to win, regardless of the impact on the other party."
                  </p>
                </div>
                <div className="sub-panel">
                  <h4>What is Cooperativeness?</h4>
                  <p style={{ color: T.slate, fontSize: ".82rem", margin: "0 0 .75rem", textAlign: "justify" }}>
                    Mutual Gain Bargaining approaches negotiation as a mutual problem-solving exercise. Relying on open communication, trust, and mutual respect, negotiators focus on fulfilling the mutual interests of both parties. In the negotiation literature, this orientation is referred to as Cooperativeness.
                  </p>
                  <div style={{ fontSize: ".68rem", fontWeight: 800, letterSpacing: ".05em", textTransform: "uppercase", color: T.navy, marginBottom: "4px" }}>Ask Yourself</div>
                  <p style={{ fontSize: ".78rem", fontStyle: "italic", color: T.ink, margin: "0 0 .6rem" }}>
                    "How strongly am I trying to understand and address what the other party wants?"
                  </p>
                  <div style={{ fontSize: ".68rem", fontWeight: 800, letterSpacing: ".05em", textTransform: "uppercase", color: "#2c8a5e", marginBottom: "4px" }}>Useful When</div>
                  <ul style={{ listStyle: "none", margin: "0 0 .6rem", padding: 0 }}>
                    {["The relationship matters, or both parties will work together afterward", "The problem is complex, with room to create value for both sides", "Trust and information sharing can improve the outcome"].map((t) => (
                      <li key={t} style={{ fontSize: ".78rem", lineHeight: 1.55, color: T.slate, paddingLeft: 14, position: "relative", marginBottom: 3 }}>
                        <span style={{ position: "absolute", left: 0 }}>–</span>{t}
                      </li>
                    ))}
                  </ul>
                  <div style={{ fontSize: ".68rem", fontWeight: 800, letterSpacing: ".05em", textTransform: "uppercase", color: "#a5203f", marginBottom: "4px" }}>Caution</div>
                  <p style={{ fontSize: ".78rem", lineHeight: 1.55, color: T.slate, margin: 0 }}>
                    Becomes a weakness when it means giving away too much, avoiding difficult conversations, or sacrificing your own interests to keep the other party happy.
                  </p>
                </div>
              </div>
              <p style={{ color: T.slate, fontSize: ".82rem", fontStyle: "italic", marginTop: ".75rem" }}>
                Negotiators that exhibit Assertiveness tendencies are more likely to engage in Distributive Bargaining behavior, while negotiators that are high in Cooperativeness are more likely to use a Mutual Gain Bargaining approach.
              </p>

              {/* About the Instrument */}
              <div style={{ marginTop: "1.25rem", background: "#fbfdff", border: "1px solid #DCE5EF", borderRadius: 14, padding: "1.1rem 1.25rem", display: "flex", gap: 16, alignItems: "flex-start" }}>
                <div style={{ flexShrink: 0, width: 34, height: 34, borderRadius: "50%", background: T.teal, color: "#fff", display: "flex", alignItems: "center", justifyContent: "center", fontSize: 15, fontWeight: 800 }}>i</div>
                <div>
                  <h4 style={{ margin: "0 0 .35rem", fontSize: ".85rem", color: T.navy }}>About the Instrument</h4>
                  <p style={{ margin: 0, fontSize: ".82rem", lineHeight: 1.6, color: "#241318" }}>
                    The Negotiating Styles Self-Assessment is based on the framework developed by Holley, Jennings &amp; Wolters (8th ed.), which maps how individuals approach negotiation across two underlying dimensions — Assertiveness and Cooperativeness — and the five styles that result from their combination. Acumen Business Catalyst uses this framework as part of its leadership and capability development work, translating self-report data into focused coaching conversations around negotiation effectiveness.
                  </p>
                </div>
              </div>

              {/* Why This Matters */}
              <div style={{ marginTop: "1rem", background: "#fdf3e9", border: "1px solid #f4dcc2", borderRadius: 14, padding: "1.1rem 1.25rem" }}>
                <span style={{ display: "block", fontSize: ".68rem", fontWeight: 800, letterSpacing: ".1em", textTransform: "uppercase", color: T.orange, marginBottom: 8 }}>Why This Matters</span>
                <p style={{ margin: 0, fontSize: ".82rem", lineHeight: 1.6, color: "#241318" }}>
                  Negotiation style shapes outcomes well beyond the bargaining table — it influences how someone handles vendor terms, internal resourcing conflicts, salary conversations, and cross-functional disagreements. A style that's too Assertive without Cooperativeness burns relationships; one that's too Cooperative without Assertiveness leaves value on the table. The goal isn't a single "good" style — it's knowing which style you default to under pressure, and when to deliberately shift.
                </p>
              </div>

              {/* How Scoring Works */}
              <div style={{ marginTop: "1rem", background: "#fbfdff", border: "1px solid #DCE5EF", borderRadius: 14, padding: "1.1rem 1.25rem" }}>
                <h4 style={{ margin: "0 0 .9rem", fontSize: ".95rem", color: T.navy }}>How Scoring Works</h4>
                <div style={{ display: "flex", alignItems: "stretch", gap: 0 }}>
                  {[
                    { n: 1, title: "25 Questions", desc: "Each item presents a negotiation scenario and a set of response options." },
                    { n: 2, title: "5 Style Scores", desc: "Responses are tallied into five raw scores — one per style (Competing, Collaborating, Compromising, Accommodating, Avoiding), each out of 25." },
                    { n: 3, title: "2 Indices", desc: "The five style scores combine into an Assertiveness Index and a Cooperativeness Index." },
                  ].map((s, i, arr) => (
                    <React.Fragment key={s.n}>
                      <div style={{ flex: 1, background: "#fff", border: "1px solid #DCE5EF", borderRadius: 10, padding: "14px", textAlign: "center" }}>
                        <div style={{ display: "inline-block", width: 20, height: 20, lineHeight: "20px", borderRadius: "50%", background: T.teal, color: "#fff", fontSize: ".68rem", fontWeight: 800, marginBottom: 8 }}>{s.n}</div>
                        <div style={{ fontSize: ".8rem", fontWeight: 700, marginBottom: 4, color: T.ink }}>{s.title}</div>
                        <div style={{ fontSize: ".68rem", color: T.slate, lineHeight: 1.5 }}>{s.desc}</div>
                      </div>
                      {i < arr.length - 1 && (
                        <div style={{ display: "flex", alignItems: "center", justifyContent: "center", width: 34, fontSize: 18, color: T.orange, fontWeight: 700 }}>→</div>
                      )}
                    </React.Fragment>
                  ))}
                </div>
                <div style={{ textAlign: "center", fontSize: ".72rem", color: T.slate, fontStyle: "italic", marginTop: 14 }}>
                  Your five style scores and two index scores are on the following pages.
                </div>
              </div>

            </div>
          </section>


          {/* ══════════════════════════════════════════
              PAGE 3 — A–C GRAPH
          ══════════════════════════════════════════ */}
          <section className="ns-page">
            <div className="page-inner">
              <div className="topbar">
                <div>
                  <div className="section-kicker" style={{ color: T.gold }}>Page 3</div>
                  <h2 className="section-title">Assertiveness &amp; Cooperativeness Graph</h2>
                </div>
                <div className="small">Distributive vs Mutual Gain</div>
              </div>

              <p style={{ color: T.slate, fontSize: ".88rem", margin: "0 0 1.25rem", lineHeight: 1.7 }}>
                This graph visually maps your negotiation orientation using your Assertiveness and Cooperativeness indexes. Your plotted position reflects whether your style aligns more closely with Competing, Collaborating, Avoiding, Accommodating, or Compromising behaviour.
              </p>

              <div style={{ background: "#fbfdff", border: "1px solid #DCE5EF", borderRadius: 18, padding: "1.25rem", marginBottom: "1.25rem" }}>
                <TwoDGraphSVG
                  assertivenessIndex={assertiveness?.index}
                  cooperativenessIndex={cooperativeness?.index}
                />
              </div>

              {/* Index summary below graph */}
              <div className="card" style={{ marginBottom: "1.25rem" }}>
                <h3>Reading Your Position</h3>
                <p className="lead">
                  The X-axis represents your Cooperativeness index (left = low, right = high). The Y-axis represents your Assertiveness index (down = low, up = high). The centre area marks the Compromising zone — the intersection of moderate assertiveness and cooperativeness.
                </p>
              </div>

              <div className="callout" style={{ marginBottom: "1.25rem" }}>
                Your Index scores are derived from your five style scores on the next page — comparing how strongly you lean toward assertive styles versus unassertive ones, and cooperative styles versus uncooperative ones. Each score is then placed into one of the four bands shown above: Low, Moderate to Low, Moderate to High, or High.
              </div>

              <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: "1.25rem" }}>
                {[
                  { label: "Assertiveness Index", obj: assertiveness, descMap: INDEX_DESCRIPTIONS.assertiveness },
                  { label: "Cooperativeness Index", obj: cooperativeness, descMap: INDEX_DESCRIPTIONS.cooperativeness },
                ].map(({ label, obj, descMap }) => {
                  const idx = obj?.index ?? null;
                  const bandLabel = obj?.band_label ?? "Low";
                  const bandColor = INDEX_BAND_COLOR[bandLabel] ?? INDEX_BAND_COLOR.Low;
                  const bandPos = Math.max(0, INDEX_BAND_ORDER.indexOf(bandLabel));
                  const desc = descMap?.[bandLabel] ?? "";
                  return (
                    <div key={label} style={{ background: `${bandColor}0d`, border: `1px solid ${bandColor}33`, borderRadius: 16, padding: "1.1rem 1.25rem" }}>
                      <div style={{ display: "flex", justifyContent: "space-between", alignItems: "flex-start", marginBottom: ".5rem" }}>
                        <div style={{ fontWeight: 700, fontSize: ".97rem", color: T.ink }}>{label}</div>
                        <div style={{ fontSize: "1.7rem", fontWeight: 800, color: bandColor, lineHeight: 1 }}>
                          {idx != null ? (idx > 0 ? `+${idx}` : idx) : "—"}
                        </div>
                      </div>
                      <span style={{ display: "inline-block", background: bandColor, color: "#fff", fontSize: ".68rem", fontWeight: 700, letterSpacing: ".04em", textTransform: "uppercase", borderRadius: 999, padding: "3px 12px", marginBottom: ".65rem" }}>
                        {bandLabel}
                      </span>
                      {/* Segmented band bar */}
                      <div style={{ display: "flex", gap: 4, marginBottom: ".3rem" }}>
                        {INDEX_BAND_ORDER.map((b, i) => (
                          <div key={b} style={{ flex: 1, height: 6, borderRadius: 999, background: i <= bandPos ? bandColor : `${bandColor}22` }} />
                        ))}
                      </div>
                      <div style={{ display: "flex", justifyContent: "space-between", fontSize: ".68rem", color: T.slate, marginBottom: ".65rem" }}>
                        <span>Low</span><span>Mod-Low</span><span>Mod-High</span><span>High</span>
                      </div>
                      <p style={{ margin: 0, fontSize: ".82rem", fontStyle: "italic", color: T.slate, lineHeight: 1.6 }}>{desc}</p>
                    </div>
                  );
                })}
              </div>
            </div>
          </section>
          {/* ══════════════════════════════════════════
              PAGE 4 — THE FIVE NEGOTIATING STYLES
          ══════════════════════════════════════════ */}
          <section className="ns-page">
            <div className="page-inner">
              <div className="topbar">
                <div>
                  <div className="section-kicker" style={{ color: T.gold }}>Page 4</div>
                  <h2 className="section-title">The Five Negotiating Styles</h2>
                </div>
                <div className="small">CO · CL · CM · AC · AV</div>
              </div>

              <p style={{ color: T.slate, fontSize: ".88rem", margin: "0 0 1.1rem" }}>
                Each style reflects a distinct combination of Assertiveness and Cooperativeness. Your dominant style is highlighted below.
              </p>

              {stylesForDisplaySorted.slice(0, 3).map(({ def, score, bandLabel, isDominant }) => {
                const color = STYLE_COLOR[def.code];
                return (
                  <div key={def.code} className={`profile-card${isDominant ? " active" : ""}`}
                    style={isDominant ? { borderColor: color } : {}}>
                    <div className="profile-header">
                      <div className="profile-badge-circle" style={{ background: color }}>{def.code}</div>
                      <div className="profile-meta">
                        <strong style={{ color: T.ink }}>
                          {def.label}
                          {isDominant && <span className="your-tag" style={{ background: color }}>★ Dominant</span>}
                        </strong>
                        <em>{def.tagline}</em>
                      </div>
                      <div style={{ marginLeft: "auto", textAlign: "center" }}>
                        <div style={{ fontSize: "1.7rem", fontWeight: 800, color, lineHeight: 1 }}>
                          {score ?? "—"}<span style={{ fontSize: ".85rem", fontWeight: 600, opacity: .55 }}>/25</span>
                        </div>
                        <span style={{ display: "inline-block", marginTop: ".35rem", background: color, color: "#fff", fontSize: ".68rem", fontWeight: 700, borderRadius: 999, padding: "3px 12px", whiteSpace: "nowrap" }}>{bandLabel}</span>
                      </div>
                    </div>

                    {/* Dimension badges */}
                    <div style={{ marginBottom: ".5rem" }}>
                      {[
                        `Assertiveness: ${def.assertiveness}`,
                        `Cooperativeness: ${def.cooperativeness}`,
                        def.bargaining,
                      ].map(b => (
                        <span key={b} className="dim-badge"
                          style={{ background: `${color}14`, border: `1px solid ${color}40`, color }}>
                          {b}
                        </span>
                      ))}
                    </div>

                    <p>{def.overview}</p>
                    {def.orgNote && <p style={{ color: T.slate, fontStyle: "italic",paddingBottom: ".5rem" }}>{def.orgNote}</p>}

                    {/* Active band only */}
                    {(() => {
                      const range = BAND_RANGES[def.code]?.[bandLabel] ?? "";
                      const desc = BAND_DESCRIPTIONS[def.code]?.[bandLabel] ?? "";
                      return (
                        <div className="band-section active-band" style={{ border: `1px solid ${color}40`, background: `${color}08`, marginBottom: ".75rem" }}>
                          <div style={{ fontWeight: 700, fontSize: ".8rem", color, marginBottom: ".25rem" }}>
                            {bandLabel}
                            <span style={{ marginLeft: 8, fontSize: ".68rem", background: color, color: "#fff", borderRadius: 999, padding: "1px 7px" }}>
                              Your band
                            </span>
                          </div>
                          <p style={{ margin: 0, fontSize: ".83rem", lineHeight: 1.6, color: T.ink }}>{desc}</p>
                        </div>
                      );
                    })()}

                    <div>
                      <strong style={{ fontSize: ".85rem", color: T.navy }}>Action steps:</strong>
                      <ul style={{ marginTop: ".35rem", paddingLeft: "18px", marginBottom: 0, }}>
                        {def.toDo.map((item, i) => (
                          <li key={i} style={{ marginBottom: ".3rem", color: T.ink, fontSize: ".83rem", lineHeight: 1.6 }}>{item}</li>
                        ))}
                      </ul>
                    </div>
                  </div>
                );
              })}
            </div>
          </section>

          {/* ══════════════════════════════════════════
              PAGE 5 — THE FIVE NEGOTIATING STYLES
          ══════════════════════════════════════════ */}
          <section className="ns-page">
            <div className="page-inner">
              <div className="topbar">
                <div>
                  <div className="section-kicker" style={{ color: T.gold }}>Page 5</div>
                  <h2 className="section-title">The Five Negotiating Styles</h2>
                </div>
                <div className="small">CO · CL · CM · AC · AV</div>
              </div>

              <p style={{ color: T.slate, fontSize: ".88rem", margin: "0 0 1.1rem" }}>
                Each style reflects a distinct combination of Assertiveness and Cooperativeness. Your dominant style is highlighted below.
              </p>

              {stylesForDisplaySorted.slice(3).map(({ def, score, bandLabel, isDominant }) => {
                const color = STYLE_COLOR[def.code];
                return (
                  <div key={def.code} className={`profile-card${isDominant ? " active" : ""}`}
                    style={isDominant ? { borderColor: color } : {}}>
                    <div className="profile-header">
                      <div className="profile-badge-circle" style={{ background: color }}>{def.code}</div>
                      <div className="profile-meta">
                        <strong style={{ color: T.ink }}>
                          {def.label}
                          {isDominant && <span className="your-tag" style={{ background: color }}>★ Dominant</span>}
                        </strong>
                        <em>{def.tagline}</em>
                      </div>
                      <div style={{ marginLeft: "auto", textAlign: "center" }}>
                        <div style={{ fontSize: "1.7rem", fontWeight: 800, color, lineHeight: 1 }}>
                          {score ?? "—"}<span style={{ fontSize: ".85rem", fontWeight: 600, opacity: .55 }}>/25</span>
                        </div>
                        <span style={{ display: "inline-block", marginTop: ".35rem", background: color, color: "#fff", fontSize: ".68rem", fontWeight: 700, borderRadius: 999, padding: "3px 12px", whiteSpace: "nowrap" }}>{bandLabel}</span>
                      </div>
                    </div>

                    {/* Dimension badges */}
                    <div style={{ marginBottom: ".5rem" }}>
                      {[
                        `Assertiveness: ${def.assertiveness}`,
                        `Cooperativeness: ${def.cooperativeness}`,
                        def.bargaining,
                      ].map(b => (
                        <span key={b} className="dim-badge"
                          style={{ background: `${color}14`, border: `1px solid ${color}40`, color }}>
                          {b}
                        </span>
                      ))}
                    </div>

                    <p>{def.overview}</p>
                    {def.orgNote && <p style={{ color: T.slate, fontStyle: "italic", paddingBottom: ".5rem" }}>{def.orgNote}</p>}

                    {/* Active band only */}
                    {(() => {
                      const range = BAND_RANGES[def.code]?.[bandLabel] ?? "";
                      const desc = BAND_DESCRIPTIONS[def.code]?.[bandLabel] ?? "";
                      return (
                        <div className="band-section active-band" style={{ border: `1px solid ${color}40`, background: `${color}08`, marginBottom: ".75rem" }}>
                          <div style={{ fontWeight: 700, fontSize: ".8rem", color, marginBottom: ".25rem" }}>
                            {bandLabel}
                            <span style={{ marginLeft: 8, fontSize: ".68rem", background: color, color: "#fff", borderRadius: 999, padding: "1px 7px" }}>
                              Your band
                            </span>
                          </div>
                          <p style={{ margin: 0, fontSize: ".83rem", lineHeight: 1.6, color: T.ink }}>{desc}</p>
                        </div>
                      );
                    })()}

                    <div>
                      <strong style={{ fontSize: ".85rem", color: T.navy, marginBottom: ".25rem" }}>Action steps:</strong>
                      <ul style={{ marginTop: ".35rem", paddingLeft: "18px" }}>
                        {def.toDo.map((item, i) => (
                          <li key={i} style={{ marginBottom: ".3rem", color: T.ink, fontSize: ".83rem", lineHeight: 1.6 }}>{item}</li>
                        ))}
                      </ul>
                    </div>
                  </div>
                );
              })}
            </div>
          </section>

          {/* ══════════════════════════════════════════
              BACK COVER
          ══════════════════════════════════════════ */}
          <section className="ns-page back-cover">
            <div style={{ background: `linear-gradient(135deg,${T.navy} 0%,#C4163A 50%,${T.teal} 100%)`, minHeight: "1556px" }}>
              <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", padding: "1.5rem 2.5rem", borderBottom: "1px solid rgba(255,255,255,0.15)" }}>
                <div style={{ fontSize: "0.72rem", textTransform: "uppercase", letterSpacing: ".12em", fontWeight: 700, color: "rgba(255,255,255,0.66)" }}>
                  {/* Back Cover */}
                </div>
                <div style={{ fontSize: "0.72rem", color: "rgba(255,255,255,0.5)", letterSpacing: ".05em" }}>Acumen Business Catalyst</div>
              </div>
              <div className="page-inner">
                <div style={{ display: "flex", flexDirection: "column", justifyContent: "center", flex: 1 }}>
                  <div className="closing">
                    <h2>Developing Your Negotiating Effectiveness</h2>
                    <p>
                      Negotiating style is a dynamic capability, not a fixed trait. Awareness of your
                      dominant orientation — and the conditions under which it serves or limits you — is
                      the foundation of deliberate development. Acumen Business Catalyst uses assessments
                      like this to turn behavioural data into focused conversations that build lasting
                      negotiating competence.
                    </p>
                  </div>
                </div>
                <div>
                  <div className="contact-grid">
                    <div className="contact">
                      <span>Brand</span>
                      <strong>Acumen Business Catalyst</strong>
                    </div>
                    <div className="contact">
                      <span>Focus</span>
                      <strong>Leadership • Culture • Capability</strong>
                    </div>
                    <div className="contact">
                      <span>Report type</span>
                      <strong>Individual Negotiating Style Profile</strong>
                    </div>
                  </div>
                  <p className="light" style={{ marginTop: "1.5rem", fontSize: "0.75rem" }}>
                    This report is generated from the Negotiating Styles Self-Assessment framework. Based on Holley, Jennings &amp; Wolters, 8th ed. © 2026 Acumen Business Catalyst.
                  </p>
                </div>
              </div>
            </div>
          </section>

        </main>
      </div>
    </div>
  );
}